import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Date custom scalar type */
  Date: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any };
};

export enum AssessmentWebTrialListOrderFields {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
}

export type AssessmentWebTrialListOrderInput = {
  /** Поле сортировки */
  field: AssessmentWebTrialListOrderFields;
  /** Порядок сортировка */
  order: OrderType;
};

export type AuthBySocialNetworkInput = {
  /** Код внешней авторизации */
  code: Scalars['String']['input'];
  /** VK ID PKCE code verifier */
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  /** VK ID device_id from callback */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** Провайдер внешней авторизации */
  provider: Social_Network_Provider;
  /** VK ID redirect URI */
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

export type AuthCandidateTokensDto = {
  __typename?: 'AuthCandidateTokensDto';
  accessToken: Scalars['String']['output'];
  isNew: Scalars['Boolean']['output'];
  refreshToken: Scalars['String']['output'];
};

export enum Candidate_Token_Type {
  EmailConfirmation = 'EMAIL_CONFIRMATION',
  PasswordReset = 'PASSWORD_RESET',
}

export enum Company_Candidate_Type {
  Candidate = 'CANDIDATE',
  Employee = 'EMPLOYEE',
}

export enum Company_Status {
  Approved = 'APPROVED',
  Blocked = 'BLOCKED',
  Created = 'CREATED',
  NotApproved = 'NOT_APPROVED',
  PartlyApproved = 'PARTLY_APPROVED',
}

export enum Competency_Map_Status {
  Approved = 'APPROVED',
  Archive = 'ARCHIVE',
  Draft = 'DRAFT',
  Generating = 'GENERATING',
  Virtual = 'VIRTUAL',
}

export type Candidate = {
  __typename?: 'Candidate';
  /** Согласие кандидата с офертой и обработкой его данных */
  agreement: Scalars['Boolean']['output'];
  /** Username кандидата в ТГ */
  candidateUsername: CandidateUsername;
  /** ID Username кандидата в ТГ */
  candidateUsernameId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  /** ФИО кандидата из ТГ */
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Язык кандидата */
  language?: Maybe<Language>;
  /** Номер телефона кандидата */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Токены */
  tokens?: Maybe<Array<CandidateToken>>;
  updatedAt: Scalars['Date']['output'];
};

export type CandidateAWebDto = {
  __typename?: 'CandidateAWebDto';
  /** Согласие кандидата с офертой и обработкой его данных */
  agreement: Scalars['Boolean']['output'];
  /** Username и id кандидата в ТГ */
  candidateUsername: CandidateUsernameAWebDto;
  /** ID Username кандидата в ТГ */
  candidateUsernameId: Scalars['ID']['output'];
  /** Первая сущность кандидата компании, принадлежащая текущему кандидату */
  firstCompanyCandidate?: Maybe<CompanyCandidateAWebDto>;
  /** ФИО кандидата из ТГ */
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Язык кандидата */
  language?: Maybe<Language>;
  /** Номер телефона кандидата */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CandidateToken = {
  __typename?: 'CandidateToken';
  /** кандидат */
  candidate?: Maybe<Candidate>;
  /** ID кандидата */
  candidateId?: Maybe<Scalars['ID']['output']>;
  /** Дополнительный код */
  code: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  /** Дата истечения токена */
  expiresAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Тип токена */
  type: Candidate_Token_Type;
  updatedAt: Scalars['Date']['output'];
};

export type CandidateUsername = {
  __typename?: 'CandidateUsername';
  /** Кандидат */
  candidate?: Maybe<Candidate>;
  /** Связь кандидата с компанией */
  companyCandidate?: Maybe<Array<CompanyCandidate>>;
  createdAt: Scalars['Date']['output'];
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Подтверждён ли Email */
  emailIsConfirmed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Временный логин */
  login?: Maybe<Scalars['String']['output']>;
  /** ID пользователя из telegram */
  telegramId?: Maybe<Scalars['Float']['output']>;
  /** Профиль телеграм кандидата */
  telegramUsername?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  /** Р’РЅРµС€РЅРёР№ Id СЋР·РµСЂР° РёР· VK ID */
  vkId?: Maybe<Scalars['String']['output']>;
  /** Email юзера из Яндекс */
  yandexEmail?: Maybe<Scalars['String']['output']>;
  /** Внешний Id юзера из Яндекс */
  yandexId?: Maybe<Scalars['String']['output']>;
};

export type CandidateUsernameAWebDto = {
  __typename?: 'CandidateUsernameAWebDto';
  /** Кандидат */
  candidate?: Maybe<CandidateAWebDto>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Подтверждён ли Email */
  emailIsConfirmed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Временный логин */
  login?: Maybe<Scalars['String']['output']>;
  /** ID пользователя из telegram */
  telegramId?: Maybe<Scalars['Float']['output']>;
  /** Профиль телеграм кандидата */
  telegramUsername?: Maybe<Scalars['String']['output']>;
  /** Р’РЅРµС€РЅРёР№ Id СЋР·РµСЂР° РёР· VK ID */
  vkId?: Maybe<Scalars['String']['output']>;
  /** Email юзера из Яндекс */
  yandexEmail?: Maybe<Scalars['String']['output']>;
  /** Внешний Id юзера из Яндекс */
  yandexId?: Maybe<Scalars['String']['output']>;
};

export type Company = {
  __typename?: 'Company';
  /** Дата последних изменений */
  actualityDate?: Maybe<Scalars['Float']['output']>;
  /** Соглашение на обработку персональных данных */
  agreement: Scalars['Boolean']['output'];
  /** Блоки знаний */
  companyKnowledgeBlocks?: Maybe<Array<KnowledgeBlock>>;
  /** История изменения статуса */
  companyStatusHistory?: Maybe<Array<CompanyStatusHistory>>;
  /** Пользователи компании */
  companyUsers?: Maybe<Array<CompanyUser>>;
  /** Карты компетенций компании */
  competencyMaps?: Maybe<Array<CompetencyMap>>;
  /** Номер внутреннего контракта */
  contractNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Полное наименование */
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Идентификатор компании */
  identification: Scalars['String']['output'];
  /** ИНН */
  inn: Scalars['String']['output'];
  /** Флаг суперкомпании */
  isSupercompany: Scalars['Boolean']['output'];
  /** КПП */
  kpp: Scalars['String']['output'];
  /** Дата ликвидации */
  liquidationDate?: Maybe<Scalars['Float']['output']>;
  /** ФИО руководителя */
  managerFio: Scalars['String']['output'];
  /** Должность руководителя */
  managerPosition: Scalars['String']['output'];
  /** ОГРН */
  ogrn: Scalars['String']['output'];
  /** Дата выдачи ОГРН */
  ogrnDate: Scalars['Float']['output'];
  /** Код ОКАТО */
  okato: Scalars['String']['output'];
  /** Код ОКПО */
  okpo: Scalars['String']['output'];
  /** Код ОКТМО */
  oktmo: Scalars['String']['output'];
  /** Адрес регистрации */
  registrationAddress: Scalars['String']['output'];
  /** Дата регистрации */
  registrationDate: Scalars['Float']['output'];
  /** Краткое наименование */
  shortName: Scalars['String']['output'];
  /** Cтатус организации */
  state: Organization_State;
  /** Статус компании в системе */
  status: Company_Status;
  /** Тип организации */
  type: Type_Of_Organization;
  updatedAt: Scalars['Date']['output'];
  /** Вакансии компании */
  vacancies?: Maybe<Array<Vacancy>>;
};

export type CompanyAWebDto = {
  __typename?: 'CompanyAWebDto';
  /** Дата последних изменений */
  actualityDate?: Maybe<Scalars['Float']['output']>;
  /** Полное наименование */
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Идентификатор компании */
  identification: Scalars['String']['output'];
  /** ИНН */
  inn: Scalars['String']['output'];
  /** Флаг суперкомпании */
  isSupercompany: Scalars['Boolean']['output'];
  /** КПП */
  kpp: Scalars['String']['output'];
  /** Дата ликвидации */
  liquidationDate?: Maybe<Scalars['Float']['output']>;
  /** ФИО руководителя */
  managerFio: Scalars['String']['output'];
  /** Должность руководителя */
  managerPosition: Scalars['String']['output'];
  /** ОГРН */
  ogrn: Scalars['String']['output'];
  /** Дата выдачи ОГРН */
  ogrnDate: Scalars['Float']['output'];
  /** Код ОКАТО */
  okato: Scalars['String']['output'];
  /** Код ОКПО */
  okpo: Scalars['String']['output'];
  /** Код ОКТМО */
  oktmo: Scalars['String']['output'];
  /** Адрес регистрации */
  registrationAddress: Scalars['String']['output'];
  /** Дата регистрации */
  registrationDate: Scalars['Float']['output'];
  /** Краткое наименование */
  shortName: Scalars['String']['output'];
  /** Cтатус организации */
  state: Organization_State;
  /** Статус компании в системе */
  status: Company_Status;
  /** Тип организации */
  type: Type_Of_Organization;
};

export type CompanyCandidate = {
  __typename?: 'CompanyCandidate';
  /** Username кандидата в ТГ */
  candidateUsername?: Maybe<CandidateUsername>;
  /** ID Username кандидата в ТГ */
  candidateUsernameId?: Maybe<Scalars['ID']['output']>;
  /** Компания пользователя */
  company: Company;
  /** ID компании пользователя */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  /** Файл резюме */
  cvFile?: Maybe<File>;
  /** ID файла резюме */
  cvFileId?: Maybe<Scalars['ID']['output']>;
  /** Email кандидата */
  email?: Maybe<Scalars['String']['output']>;
  /** ФИО кандидата как его заполнила компания */
  fullName: Scalars['String']['output'];
  /** Грейд кандидата */
  grade?: Maybe<Grade>;
  id: Scalars['ID']['output'];
  /** Ссылка на headhunter */
  link?: Maybe<Scalars['String']['output']>;
  /** Номер кандидата компании */
  numericId: Scalars['Float']['output'];
  /** Организация */
  organization?: Maybe<Scalars['String']['output']>;
  /** Позиция кандидата в компании */
  position?: Maybe<Scalars['String']['output']>;
  /** Тестирования кандидата */
  trials?: Maybe<Array<Trial>>;
  /** Тип кандидата компании */
  type: Company_Candidate_Type;
  updatedAt: Scalars['Date']['output'];
  /** Оценки CV по вакансиям */
  vacancyCompanyCandidates?: Maybe<Array<VacancyCompanyCandidate>>;
};

export type CompanyCandidateAWebDto = {
  __typename?: 'CompanyCandidateAWebDto';
  /** Username и id кандидата в ТГ */
  candidateUsername?: Maybe<CandidateUsernameAWebDto>;
  /** ID Username кандидата в ТГ */
  candidateUsernameId?: Maybe<Scalars['ID']['output']>;
  /** Компания */
  company: CompanyAWebDto;
  /** ID компании пользователя */
  companyId: Scalars['ID']['output'];
  /** Email кандидата */
  email?: Maybe<Scalars['String']['output']>;
  /** ФИО кандидата как его заполнила компания */
  fullName: Scalars['String']['output'];
  /** Грейд кандидата */
  grade?: Maybe<Grade>;
  id: Scalars['ID']['output'];
  /** Номер кандидата компании */
  numericId: Scalars['Float']['output'];
  /** Организация */
  organization?: Maybe<Scalars['String']['output']>;
  /** Позиция кандидата в компании */
  position?: Maybe<Scalars['String']['output']>;
};

export type CompanyStatusHistory = {
  __typename?: 'CompanyStatusHistory';
  /** Компания пользователя */
  company: Company;
  /** ID компании пользователя */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Новый статус компании */
  newStatus: Company_Status;
  updatedAt: Scalars['Date']['output'];
};

export type CompanyUser = {
  __typename?: 'CompanyUser';
  /** Компания пользователя */
  company: Company;
  /** ID компании пользователя */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Флаг подтверждения */
  isConfirmed: Scalars['Boolean']['output'];
  /** Является ли создателем компании */
  isCreator: Scalars['Boolean']['output'];
  /** Является ли руководителем */
  isSupervisor: Scalars['Boolean']['output'];
  /** Должность */
  position: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Email пользователя */
  userEmail: UserEmail;
  /** ID email пользователя */
  userEmailId: Scalars['ID']['output'];
};

export type Competence = {
  __typename?: 'Competence';
  /** Карта компетенции */
  competencyMap: CompetencyMap;
  /** ID карты компетенции */
  competencyMapId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Компетенции блока */
  knowledgeBlockCompetences?: Maybe<Array<KnowledgeBlockCompetence>>;
  /** Порядок компетенции в карте компетенций */
  order: Scalars['Int']['output'];
  /** Название компетенции */
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CompetenceAWebDto = {
  __typename?: 'CompetenceAWebDto';
  /** Карта компетенций */
  competencyMap: CompetencyMapAWebDto;
  /** ID карты компетенции */
  competencyMapId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Компетенции блока */
  knowledgeBlockCompetences?: Maybe<Array<KnowledgeBlockCompetenceAWebDto>>;
  /** Порядок компетенции в карте компетенций */
  order: Scalars['Int']['output'];
  /** Название компетенции */
  title: Scalars['String']['output'];
};

export type CompetencyMap = {
  __typename?: 'CompetencyMap';
  /** Логи генерации */
  MlLogs?: Maybe<Array<MlLog>>;
  /** Комментарий к карте компетенций */
  comment?: Maybe<Scalars['String']['output']>;
  /** Компания */
  company: Company;
  /** ID компании */
  companyId: Scalars['ID']['output'];
  /** Компетенции карты компетенций */
  competences?: Maybe<Array<Competence>>;
  /** Скопированные карты компетенций */
  copies?: Maybe<Array<CompetencyMap>>;
  createdAt: Scalars['Date']['output'];
  /** Дата "мягкого" удаления */
  deletedAt?: Maybe<Scalars['Date']['output']>;
  demoCode?: Maybe<Scalars['String']['output']>;
  /** Типовые тестирования */
  examinations?: Maybe<Array<Examination>>;
  id: Scalars['ID']['output'];
  /** Использовать проверку репозитория */
  isRepositoryCheck: Scalars['Boolean']['output'];
  /** Флаг примера */
  isSample: Scalars['Boolean']['output'];
  /** Номер карты компетенций компании */
  numericId: Scalars['Float']['output'];
  /** Оригинальная карта компетенций */
  originalCompetencyMap?: Maybe<CompetencyMap>;
  /** ID оригинальной карты компетенции */
  originalCompetencyMapId?: Maybe<Scalars['ID']['output']>;
  /** Специализация карты компетенций */
  specialization: Scalars['String']['output'];
  /** Статус карты */
  status: Competency_Map_Status;
  /** Название карты компетенций */
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Использовать карту компетенций в боте */
  useInBot: Scalars['Boolean']['output'];
  /** Версия карты компетенций */
  version: Scalars['Float']['output'];
};

export type CompetencyMapAWebDto = {
  __typename?: 'CompetencyMapAWebDto';
  /** Комментарий к карте компетенций */
  comment?: Maybe<Scalars['String']['output']>;
  /** Компания, которой принадлежит карта */
  company: CompanyAWebDto;
  /** ID компании */
  companyId: Scalars['ID']['output'];
  /** Компетенции карты компетенций */
  competences?: Maybe<Array<CompetenceAWebDto>>;
  id: Scalars['ID']['output'];
  /** Использовать проверку репозитория */
  isRepositoryCheck: Scalars['Boolean']['output'];
  /** Флаг примера */
  isSample: Scalars['Boolean']['output'];
  /** Номер карты компетенций компании */
  numericId: Scalars['Float']['output'];
  /** Специализация карты компетенций */
  specialization: Scalars['String']['output'];
  /** Статус карты */
  status: Competency_Map_Status;
  /** Название карты компетенций */
  title: Scalars['String']['output'];
};

export type CriterionAssessment = {
  __typename?: 'CriterionAssessment';
  criteria: Scalars['String']['output'];
  decision: Scalars['String']['output'];
  explanation?: Maybe<Scalars['String']['output']>;
};

export type CvCheck = {
  __typename?: 'CvCheck';
  /** Логи оценки */
  MlLogs?: Maybe<Array<MlLog>>;
  /** Оценки по skills */
  assessmentCV?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['Date']['output'];
  /** CV кандидата */
  cvFile: File;
  /** Id CV кандидата */
  cvFileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Отчет по оценка CV */
  reportFile?: Maybe<File>;
  /** Id отчета по оценке CV */
  reportFileId?: Maybe<Scalars['ID']['output']>;
  /** Оценка CV */
  score?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
  /** Кандидат вакансии */
  vacancyCompanyCandidate: Array<VacancyCompanyCandidate>;
  /** Id кандидата вакансии */
  vacancyCompanyCandidateId: Scalars['ID']['output'];
};

export enum Examination_Type {
  Group = 'GROUP',
  Open = 'OPEN',
  Personal = 'PERSONAL',
  Public = 'PUBLIC',
}

export type Examination = {
  __typename?: 'Examination';
  /** Дата доступа к тестирвоанию от */
  availableFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата доступа к тестирвоанию до */
  availableTo?: Maybe<Scalars['Date']['output']>;
  /** Карта компетенций */
  competencyMap: CompetencyMap;
  /** Id карты компетенций */
  competencyMapId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  /** Генерировать ли дополнитедьные комментарии для данных отчёта */
  genAltReportData: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Активно ли тестирование */
  isActive: Scalars['Boolean']['output'];
  /** Является ли тестирование интервью */
  isInterview: Scalars['Boolean']['output'];
  /** Отправлять ли результат канидату */
  isSendResult: Scalars['Boolean']['output'];
  /** Максимальное количество дополнительных вопросов для вопроса в интервью */
  maxFollowups?: Maybe<Scalars['Int']['output']>;
  /** Номер тестирования */
  numericId: Scalars['Float']['output'];
  /** Порого в процентах для прхождения тестирования */
  passingThreshold: Scalars['Int']['output'];
  /** Промежуток в днях для отправки напоминающего сообщения */
  reminderSchedule?: Maybe<Scalars['Int']['output']>;
  /** Отправлять ли напоминающее сообщение */
  sendReminder: Scalars['Boolean']['output'];
  /** Тип отчета для отправки */
  sendResultType: Trial_File_Type;
  /** Порог в вроцентах для завершения вопроса в интервью  (0.01 - 1.00) */
  threshold?: Maybe<Scalars['Int']['output']>;
  /** Название тестирования */
  title: Scalars['String']['output'];
  /** Тестирования кандидатов */
  trials?: Maybe<Array<Trial>>;
  /** Тип тестирования */
  type: Examination_Type;
  updatedAt: Scalars['Date']['output'];
};

export type ExaminationAWebDto = {
  __typename?: 'ExaminationAWebDto';
  /** Дата доступа к тестирвоанию от */
  availableFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата доступа к тестирвоанию до */
  availableTo?: Maybe<Scalars['Date']['output']>;
  /** Карта компетенций */
  competencyMap: CompetencyMapAWebDto;
  /** Id карты компетенций */
  competencyMapId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Является ли тестирование интервью */
  isInterview: Scalars['Boolean']['output'];
  /** Отправлять ли результат канидату */
  isSendResult: Scalars['Boolean']['output'];
  /** Номер тестирования */
  numericId: Scalars['Float']['output'];
  /** Тип отчета для отправки */
  sendResultType: Trial_File_Type;
  /** Тестирования кандидатов */
  trials?: Maybe<Array<TrialAWebDto>>;
};

export type File = {
  __typename?: 'File';
  /** Ответы кандидата по тестированию */
  answers?: Maybe<Array<TrialAnswer>>;
  /** CV кандидата */
  companyCandidates?: Maybe<Array<CompanyCandidate>>;
  createdAt: Scalars['Date']['output'];
  /** CV кандидата для истории оценок */
  cvFiles?: Maybe<Array<CvCheck>>;
  /** Расширение файла */
  extension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Ключ файла в S3 */
  key: Scalars['String']['output'];
  /** Название файла */
  name: Scalars['String']['output'];
  /** Отчет по оценки CV */
  reportFiles?: Maybe<Array<CvCheck>>;
  /** Отчеты по тестированию */
  trialFiles?: Maybe<Array<TrialFile>>;
  updatedAt: Scalars['Date']['output'];
  /** Ссылка на файл */
  url: Scalars['String']['output'];
};

export type FileAWebDto = {
  __typename?: 'FileAWebDto';
  /** Расширение файла */
  extension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Ключ файла в S3 */
  key: Scalars['String']['output'];
  /** Название файла */
  name: Scalars['String']['output'];
  /** Ссылка на файл */
  url: Scalars['String']['output'];
};

export enum Grade {
  Junior = 'Junior',
  Middle = 'Middle',
  Senior = 'Senior',
}

export type GenerateReportFileInput = {
  /** Id тестирования */
  trialId: Scalars['ID']['input'];
  /** Тип отчета */
  type: Trial_File_Type;
};

export enum Interview_Reply_Event {
  CandidateMessage = 'CANDIDATE_MESSAGE',
  Error = 'ERROR',
  Finish = 'FINISH',
  Followup = 'FOLLOWUP',
  Question = 'QUESTION',
}

export type InterviewReplyMessage = {
  __typename?: 'InterviewReplyMessage';
  /** Содержание сообщения */
  content: Scalars['String']['output'];
  /** Тип события в сообщении */
  event: Interview_Reply_Event;
};

export type InterviewSendAnswerInput = {
  /** Ответ кандидата на вопрос */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Дополнительные данные об ответе */
  metadata?: InputMaybe<SaveAnswerMetadataInput>;
  /** Id сессии интервью */
  sessionId: Scalars['ID']['input'];
  /** Время затраченное на ответ кандидата */
  time?: InputMaybe<Scalars['Float']['input']>;
};

export type KnowledgeBlock = {
  __typename?: 'KnowledgeBlock';
  /** Компания */
  company: Company;
  /** ID компании */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Флаг удаления */
  isDeleted: Scalars['Boolean']['output'];
  /** Компетенции Блока */
  knowledgeBlockCompetences?: Maybe<Array<KnowledgeBlockCompetence>>;
  /** Профессия */
  profession: Scalars['String']['output'];
  /** Навыки компетенции */
  skills?: Maybe<Array<Skill>>;
  /** Название блока знаний */
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type KnowledgeBlockAWebDto = {
  __typename?: 'KnowledgeBlockAWebDto';
  id: Scalars['ID']['output'];
  /** Профессия */
  profession: Scalars['String']['output'];
  /** Название блока знаний */
  title: Scalars['String']['output'];
};

export type KnowledgeBlockCompetence = {
  __typename?: 'KnowledgeBlockCompetence';
  /** Компетенция */
  competence: Competence;
  /** ID Компетенции */
  competenceId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Блоки знаний */
  knowledgeBlock: KnowledgeBlock;
  /** ID Блока знаний */
  knowledgeBlockId: Scalars['ID']['output'];
  /** Порядок компетенции в блоке */
  order: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type KnowledgeBlockCompetenceAWebDto = {
  __typename?: 'KnowledgeBlockCompetenceAWebDto';
  /** Компетенция */
  competence: CompetenceAWebDto;
  /** ID Компетенции */
  competenceId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Блок знаний */
  knowledgeBlock: KnowledgeBlockAWebDto;
  /** ID Блока знаний */
  knowledgeBlockId: Scalars['ID']['output'];
};

export enum Language {
  En = 'en',
  Kk = 'kk',
  Ru = 'ru',
  Uz = 'uz',
}

export type ListTrialFilterInput = {
  /** ID компании, в которой проходил тестирование */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  /** Название карты компетенций */
  competencyMapTitle?: InputMaybe<Scalars['String']['input']>;
  /** Дата завершения тестирования, отправлять нужное число в локальном часовом поясе c временем 00:00:000 */
  completedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Статус тестирования */
  status?: InputMaybe<Trial_Status>;
};

export enum Ml_Log_Event {
  AssessAnswer = 'assess_answer',
  CmFromDescription = 'cm_from_description',
  CmFromVacancy = 'cm_from_vacancy',
  GenerateAltReport = 'generate_alt_report',
  GenerateQuestions = 'generate_questions',
  GenerateReport = 'generate_report',
  Regenerate = 'regenerate',
  RegenerateSync = 'regenerate_sync',
  RelevanceAssessment = 'relevance_assessment',
}

export enum Ml_Log_Status {
  Error = 'ERROR',
  Initialized = 'INITIALIZED',
  InternalError = 'INTERNAL_ERROR',
  RequestFailed = 'REQUEST_FAILED',
  Success = 'SUCCESS',
}

export type MlLog = {
  __typename?: 'MlLog';
  /** Карта компетенций */
  competencyMap?: Maybe<CompetencyMap>;
  /** ID Карты компетенций */
  competencyMapId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Оценка CV */
  cvCheck?: Maybe<CvCheck>;
  /** ID Оценки CV */
  cvCheckId?: Maybe<Scalars['ID']['output']>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Тип лога */
  event: Ml_Log_Event;
  id: Scalars['ID']['output'];
  /** Вопрос */
  question?: Maybe<Question>;
  /** ID Вопроса */
  questionId?: Maybe<Scalars['ID']['output']>;
  /** Данные запроса */
  requestData?: Maybe<Scalars['JSON']['output']>;
  /** Id запроса */
  requestId: Scalars['ID']['output'];
  /** Данные ответа */
  responseData?: Maybe<Scalars['JSON']['output']>;
  /** Навык (при генерации вопросов) */
  skill?: Maybe<Skill>;
  /** ID топика */
  skillId?: Maybe<Scalars['ID']['output']>;
  /** Статус лога */
  status: Ml_Log_Status;
  /** Тестирование */
  trial?: Maybe<Trial>;
  /** Ответ (при оценке ответа */
  trialAnswer?: Maybe<TrialAnswer>;
  /** ID Ответа */
  trialAnswerId?: Maybe<Scalars['ID']['output']>;
  /** ID Карты компетенций */
  trialId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Отмена начатого тестирования */
  cancelTrial: TrialAWebDto;
  /** Подтверждение имейла */
  confirmEmail: Scalars['Boolean']['output'];
  createTrialForOpenedExamination: TrialAWebDto;
  /** Отсрочить вопрос */
  delayQuestion: Array<TrialQuestionListElement>;
  /** Файл отчета */
  generateReportFile?: Maybe<TrialFileAWebDto>;
  /** Иннициализация подтверждение имейла */
  initConfirmEmail: Scalars['Boolean']['output'];
  /** Иннициализация восстановления пароля */
  initResetPassword: Scalars['Boolean']['output'];
  /** Обработка ответа кандидата на вопрос в интервью */
  interviewSendAnswer: Scalars['Boolean']['output'];
  linkEmail: CandidateAWebDto;
  /** Авторизация по имейлу и паролю */
  loginByEmail: AuthCandidateTokensDto;
  /** Авторизация по логину и паролю */
  loginByLogin: AuthCandidateTokensDto;
  /** Авторизация по токену с данными из виджета авторизации телеграмма */
  loginBySocialNetwork: AuthCandidateTokensDto;
  /** Авторизация по токену с данными из виджета авторизации телеграмма */
  loginByTelegramToken: AuthCandidateTokensDto;
  /** Авторизация по токену с данными из телеграмма */
  loginByTelegramWebAppToken: AuthCandidateTokensDto;
  /** Обновление токенов авторизации */
  refreshTokens: AuthCandidateTokensDto;
  /** Регистрация по имейлу и паролю */
  registerByEmail: AuthCandidateTokensDto;
  registerCandidateByPublicExamination: AuthCandidateTokensDto;
  /** Восстановление пароля */
  resetPassword: Scalars['Boolean']['output'];
  /** Отправка bug report кандидатом */
  sendBugReport: Scalars['Boolean']['output'];
  /** Сохранение ответа кандидата на вопрос */
  saveAnswer: Scalars['Boolean']['output'];
  setCandidateAgreementTrue: CandidateAWebDto;
  setCandidateLanguage: CandidateAWebDto;
  setCandidatePhoneNumber: CandidateAWebDto;
  /** Пропустить вопрос */
  skipQuestion: Array<TrialQuestionListElement>;
  /** Транскрибация голосового сообщения в VTT */
  speechToText: Scalars['String']['output'];
  /** Вопрос для тестирования */
  startQuestion: StartQuestionAWebDto;
  /** Старт тестирования */
  startTrial: TrialAWebDto;
  /** Приостановаить тестирование */
  suspendTrial: TrialAWebDto;
  updateFirstCompanyCandidate: CompanyCandidateAWebDto;
};

export type MutationCancelTrialArgs = {
  trialId: Scalars['String']['input'];
};

export type MutationConfirmEmailArgs = {
  token: Scalars['String']['input'];
};

export type MutationCreateTrialForOpenedExaminationArgs = {
  examinationId: Scalars['String']['input'];
};

export type MutationDelayQuestionArgs = {
  input: QuestionForTrialActionInput;
};

export type MutationGenerateReportFileArgs = {
  input: GenerateReportFileInput;
};

export type MutationInitResetPasswordArgs = {
  email: Scalars['String']['input'];
};

export type MutationInterviewSendAnswerArgs = {
  input: InterviewSendAnswerInput;
};

export type MutationLinkEmailArgs = {
  email: Scalars['String']['input'];
};

export type MutationLoginByEmailArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationLoginByLoginArgs = {
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationLoginBySocialNetworkArgs = {
  input: AuthBySocialNetworkInput;
};

export type MutationLoginByTelegramTokenArgs = {
  token: Scalars['String']['input'];
};

export type MutationLoginByTelegramWebAppTokenArgs = {
  token: Scalars['String']['input'];
};

export type MutationRefreshTokensArgs = {
  refreshToken: Scalars['String']['input'];
};

export type MutationRegisterByEmailArgs = {
  input: RegisterCandidateEmailInput;
};

export type MutationRegisterCandidateByPublicExaminationArgs = {
  input: RegisterCandidateByPublicExaminationInput;
};

export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationSendBugReportArgs = {
  input: SendBugReportInput;
};

export type MutationSaveAnswerArgs = {
  input: SaveAnswerInput;
};

export type MutationSetCandidateLanguageArgs = {
  language: Language;
};

export type MutationSetCandidatePhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};

export type MutationSkipQuestionArgs = {
  input: QuestionForTrialActionInput;
};

export type MutationSpeechToTextArgs = {
  file: Scalars['Upload']['input'];
};

export type MutationStartQuestionArgs = {
  input: QuestionForTrialInput;
};

export type MutationStartTrialArgs = {
  trialId: Scalars['String']['input'];
};

export type MutationSuspendTrialArgs = {
  trialId: Scalars['String']['input'];
};

export type MutationUpdateFirstCompanyCandidateArgs = {
  input: UpdateFirstCreatedCompaniesInput;
};

export enum Organization_State {
  Active = 'ACTIVE',
  Bankrupt = 'BANKRUPT',
  Liquidated = 'LIQUIDATED',
  Liquidating = 'LIQUIDATING',
  Reorganizing = 'REORGANIZING',
}

export enum OrderType {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type PaginatedTrialAWebDto = {
  __typename?: 'PaginatedTrialAWebDto';
  /** Данные на указанной странице */
  data?: Maybe<Array<TrialAWebDto>>;
  /** Есть ли следующая страница */
  hasNextPage: Scalars['Boolean']['output'];
  /** Есть ли предыдущая странца */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Номер страницы (отсчёт с 0) */
  limit: Scalars['Float']['output'];
  /** Общее число записей */
  page: Scalars['Float']['output'];
  /** Ограничение количества записей на странице */
  totalCount: Scalars['Float']['output'];
};

export type PlainCompanyDto = {
  __typename?: 'PlainCompanyDto';
  /** Дата последних изменений */
  actualityDate?: Maybe<Scalars['Float']['output']>;
  /** Соглашение на обработку персональных данных */
  agreement: Scalars['Boolean']['output'];
  /** Номер внутреннего контракта */
  contractNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Полное наименование */
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Идентификатор компании */
  identification: Scalars['String']['output'];
  /** ИНН */
  inn: Scalars['String']['output'];
  /** Флаг суперкомпании */
  isSupercompany: Scalars['Boolean']['output'];
  /** КПП */
  kpp: Scalars['String']['output'];
  /** Дата ликвидации */
  liquidationDate?: Maybe<Scalars['Float']['output']>;
  /** ФИО руководителя */
  managerFio: Scalars['String']['output'];
  /** ОГРН */
  ogrn: Scalars['String']['output'];
  /** Дата выдачи ОГРН */
  ogrnDate: Scalars['Float']['output'];
  /** Код ОКАТО */
  okato: Scalars['String']['output'];
  /** Код ОКПО */
  okpo: Scalars['String']['output'];
  /** Код ОКТМО */
  oktmo: Scalars['String']['output'];
  /** Адрес регистрации */
  registrationAddress: Scalars['String']['output'];
  /** Дата регистрации */
  registrationDate: Scalars['Float']['output'];
  /** Краткое наименование */
  shortName: Scalars['String']['output'];
  /** Cтатус организации */
  state: Organization_State;
  /** Статус компании в системе */
  status: Company_Status;
  /** Тип организации */
  type: Type_Of_Organization;
  updatedAt: Scalars['Date']['output'];
};

export type PlainMlLogDto = {
  __typename?: 'PlainMlLogDto';
  /** ID Карты компетенций */
  competencyMapId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  /** ID Оценки CV */
  cvCheckId?: Maybe<Scalars['ID']['output']>;
  /** Ошибка */
  error?: Maybe<Scalars['String']['output']>;
  /** Тип лога */
  event: Ml_Log_Event;
  id: Scalars['ID']['output'];
  /** Данные запроса */
  requestData?: Maybe<Scalars['JSON']['output']>;
  /** Id запроса */
  requestId: Scalars['ID']['output'];
  /** Данные ответа */
  responseData?: Maybe<Scalars['JSON']['output']>;
  /** ID топика */
  skillId?: Maybe<Scalars['ID']['output']>;
  /** Статус лога */
  status: Ml_Log_Status;
  /** ID Ответа */
  trialAnswerId?: Maybe<Scalars['ID']['output']>;
  /** ID Карты компетенций */
  trialId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export enum Question_Correct_Count_Type {
  MultipleCorrect = 'multiple_correct',
  SingleCorrect = 'single_correct',
}

export enum Question_Type {
  MultipleChoiceQuestions = 'multiple_choice_questions',
  Practical = 'practical',
  Theoretical = 'theoretical',
}

export type Query = {
  __typename?: 'Query';
  /** Собщения в текущем интервью */
  interviewCurrentMessages: Array<InterviewReplyMessage>;
  /** Активно ли тестирвание */
  isExaminationActive: Scalars['Boolean']['output'];
  /** Текущий пользователь */
  me: CandidateAWebDto;
  /** Получения списка вопросов для тестирования и информации о нем */
  trialInfo: TrialInfoAWebDto;
  /** Список тестирований кандидата */
  trials: PaginatedTrialAWebDto;
};

export type QueryInterviewCurrentMessagesArgs = {
  sessionId: Scalars['ID']['input'];
};

export type QueryIsExaminationActiveArgs = {
  examinationId: Scalars['String']['input'];
};

export type QueryTrialInfoArgs = {
  trialId: Scalars['String']['input'];
};

export type QueryTrialsArgs = {
  filter: ListTrialFilterInput;
  limit: Scalars['Float']['input'];
  order: AssessmentWebTrialListOrderInput;
  page: Scalars['Float']['input'];
};

export type Question = {
  __typename?: 'Question';
  /** Логи генерации */
  MlLogs?: Maybe<Array<MlLog>>;
  /** Ответы кандидата по тестированию */
  answers?: Maybe<Array<TrialAnswer>>;
  /** Подтверждён ли вопрос */
  confirmation: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  /** Критерии вопроса */
  criterion: Array<Scalars['String']['output']>;
  /** Грейд вопроса */
  grade: Grade;
  id: Scalars['ID']['output'];
  /** Флаг удаления */
  isDeleted: Scalars['Boolean']['output'];
  /** Язык вопроса */
  language: Language;
  /** Микрокритерии вопроса */
  microCriterion?: Maybe<Array<Scalars['String']['output']>>;
  /** Элементы вопроса */
  parts?: Maybe<Array<QuestionPart>>;
  /** Рекомендуемое количество секунд отведённых на вопрос */
  recommendedTime?: Maybe<Scalars['Float']['output']>;
  /** Эталонный ответ на вопрос */
  referenceAnswer?: Maybe<Scalars['String']['output']>;
  /** Навык */
  skill: Skill;
  /** ID топика */
  skillId: Scalars['ID']['output'];
  /** Подтип вопроса */
  subtype?: Maybe<Scalars['String']['output']>;
  /** Текст вопроса */
  text: Scalars['String']['output'];
  /** Количество секунд отведённых на вопрос */
  time: Scalars['Float']['output'];
  /** Тип вопроса */
  type: Question_Type;
  updatedAt: Scalars['Date']['output'];
};

export type QuestionAWebDto = {
  __typename?: 'QuestionAWebDto';
  /** Подтверждён ли вопрос */
  confirmation: Scalars['Boolean']['output'];
  /** Тип определяющий количество правильных ответов для тестового вопроса */
  correctCountType?: Maybe<Question_Correct_Count_Type>;
  /** Критерии вопроса */
  criterion: Array<Scalars['String']['output']>;
  /** Грейд вопроса */
  grade: Grade;
  id: Scalars['ID']['output'];
  /** Язык вопроса */
  language: Language;
  /** Элементы вопроса */
  parts?: Maybe<Array<QuestionPartAWebDto>>;
  /** Рекомендуемое количество секунд отведённых на вопрос */
  recommendedTime?: Maybe<Scalars['Float']['output']>;
  /** Топик */
  skill: SkillAWebDto;
  /** ID топика */
  skillId: Scalars['ID']['output'];
  /** Текст вопроса */
  text: Scalars['String']['output'];
  /** Количество секунд отведённых на вопрос */
  time: Scalars['Float']['output'];
  /** Тип вопроса */
  type: Question_Type;
};

export type QuestionForTrialActionInput = {
  /** Количество секунд затраченных кандидатом */
  candidateTime?: InputMaybe<Scalars['Float']['input']>;
  /** Id вопроса */
  questionId: Scalars['ID']['input'];
  /** Id тестирования */
  trialId: Scalars['ID']['input'];
};

export type QuestionForTrialInput = {
  /** Id вопроса */
  questionId: Scalars['ID']['input'];
  /** Id тестирования */
  trialId: Scalars['ID']['input'];
};

export type QuestionPart = {
  __typename?: 'QuestionPart';
  /** Содержание элемента вопроса */
  content: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Является ли ответ верным */
  isCorrect: Scalars['Boolean']['output'];
  /** Порядок элемента */
  order: Scalars['Float']['output'];
  /** Вопрос */
  question: Question;
  /** ID топика */
  questionId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type QuestionPartAWebDto = {
  __typename?: 'QuestionPartAWebDto';
  /** Содержание элемента вопроса */
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Порядок элемента */
  order: Scalars['Float']['output'];
  /** ID топика */
  questionId: Scalars['ID']['output'];
};

export type RegisterCandidateByPublicExaminationInput = {
  /** Имейл кандидата */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Id типового тестирвоания */
  examinationId: Scalars['ID']['input'];
  /** Полное имя кандидата */
  fullName: Scalars['String']['input'];
  /** Номер телефона кандидата */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterCandidateEmailInput = {
  /** Email кандидата */
  email: Scalars['String']['input'];
  /** Полное имя кандидата */
  fullName: Scalars['String']['input'];
  /** Пароль */
  password: Scalars['String']['input'];
  /** Номер телефона кандидата */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum Social_Network_Provider {
  Vk = 'VK',
  Yandex = 'YANDEX',
}

export type SendBugReportInput = {
  /** Описание репорта */
  description: Scalars['String']['input'];
  /** Тема репорта */
  topic: Scalars['String']['input'];
};

export type SaveAnswerInput = {
  /** Ответ кандидата на вопрос */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Аудио файл ответа */
  audioFile?: InputMaybe<Scalars['Upload']['input']>;
  /** Дополнительные данные об ответе */
  metadata?: InputMaybe<SaveAnswerMetadataInput>;
  /** Выбранные варианты ответа */
  partsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Id вопроса */
  questionId: Scalars['ID']['input'];
  /** Время затраченное на ответ кандидата */
  time: Scalars['Float']['input'];
  /** Id тестирования */
  trialId: Scalars['ID']['input'];
};

export type SaveAnswerMetadataInput = {
  /** Количество вставок */
  insertCount?: InputMaybe<Scalars['Float']['input']>;
  /** Количество вставленных символов */
  insertSymbols?: InputMaybe<Scalars['Float']['input']>;
};

export type Skill = {
  __typename?: 'Skill';
  /** Логи генерации вопросов */
  MlLogs?: Maybe<Array<MlLog>>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Флаг удаления */
  isDeleted: Scalars['Boolean']['output'];
  /** Блоки знаний */
  knowledgeBlock: KnowledgeBlock;
  /** ID Блока знаний */
  knowledgeBlockId: Scalars['ID']['output'];
  /** Порядок топика в компетенции */
  order: Scalars['Int']['output'];
  /** Вопросы навыка */
  questions?: Maybe<Array<Question>>;
  /** Название топика */
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SkillAWebDto = {
  __typename?: 'SkillAWebDto';
  id: Scalars['ID']['output'];
  /** Блок знаний */
  knowledgeBlock: KnowledgeBlockAWebDto;
  /** ID Блока знаний */
  knowledgeBlockId: Scalars['ID']['output'];
  /** Порядок топика в компетенции */
  order: Scalars['Int']['output'];
  /** Название топика */
  title: Scalars['String']['output'];
};

export type StartQuestionAWebDto = {
  __typename?: 'StartQuestionAWebDto';
  /** Подтверждён ли вопрос */
  confirmation: Scalars['Boolean']['output'];
  /** Тип определяющий количество правильных ответов для тестового вопроса */
  correctCountType?: Maybe<Question_Correct_Count_Type>;
  /** Критерии вопроса */
  criterion: Array<Scalars['String']['output']>;
  /** Грейд вопроса */
  grade: Grade;
  id: Scalars['ID']['output'];
  /** Язык вопроса */
  language: Language;
  /** Элементы вопроса */
  parts?: Maybe<Array<QuestionPartAWebDto>>;
  /** Список вопросов */
  questionList: Array<TrialQuestionListElement>;
  /** Рекомендуемое количество секунд отведённых на вопрос */
  recommendedTime?: Maybe<Scalars['Float']['output']>;
  /** Топик */
  skill: SkillAWebDto;
  /** ID топика */
  skillId: Scalars['ID']['output'];
  /** Текст вопроса */
  text: Scalars['String']['output'];
  /** Количество секунд отведённых на вопрос */
  time: Scalars['Float']['output'];
  /** Тип вопроса */
  type: Question_Type;
};

export type Subscription = {
  __typename?: 'Subscription';
  interviewReply?: Maybe<InterviewReplyMessage>;
};

export type SubscriptionInterviewReplyArgs = {
  sessionId: Scalars['ID']['input'];
};

export enum Trial_File_Type {
  CandidateReport = 'CANDIDATE_REPORT',
  RecruiterReport = 'RECRUITER_REPORT',
}

export enum Trial_Question_Status {
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Pending = 'PENDING',
  PendingFollowup = 'PENDING_FOLLOWUP',
  Skipped = 'SKIPPED',
  Started = 'STARTED',
}

export enum Trial_Status {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Received = 'RECEIVED',
  Started = 'STARTED',
  Suspended = 'SUSPENDED',
}

export enum Type_Of_Organization {
  Individual = 'INDIVIDUAL',
  Legal = 'LEGAL',
}

export type Trial = {
  __typename?: 'Trial';
  /** Логи генерации */
  MlLogs?: Maybe<Array<MlLog>>;
  /** ID чата с ботом в telegram */
  botChatId?: Maybe<Scalars['Float']['output']>;
  /** Комментарий к тестированию */
  comment?: Maybe<Scalars['String']['output']>;
  /** Кандидат компании */
  companyCandidate: CompanyCandidate;
  /** ID Кандидата компании */
  companyCandidateId: Scalars['ID']['output'];
  /** Дата завершения тестирования */
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Тип тестирования */
  examination: Examination;
  /** Id типа тестирования */
  examinationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Просмотренно ли тестирвоание */
  isViewed?: Maybe<Scalars['Boolean']['output']>;
  /** Числовой id тестирования */
  numericId: Scalars['Float']['output'];
  /** Список вопросов */
  questionList?: Maybe<Array<TrialQuestionListElement>>;
  /** Генерировать вопросы картинкой */
  questionsAsImage: Scalars['Boolean']['output'];
  /** Данные для отчёта от мл */
  reportData?: Maybe<TrialReportData>;
  /** Id сессии интервью */
  sessionId?: Maybe<Scalars['ID']['output']>;
  /** Статус тестирования */
  status: Trial_Status;
  /** Ответы кандидата по тестированию */
  trialAnswers?: Maybe<Array<TrialAnswer>>;
  /** Отчеты по тестированию */
  trialFiles?: Maybe<Array<TrialFile>>;
  /** Результаты проверки репозитория */
  trialRepositoryChecks: Array<TrialRepositoryCheck>;
  /** История статусов тестирования */
  trialStatusHistory?: Maybe<Array<TrialStatusHistory>>;
  updatedAt: Scalars['Date']['output'];
};

export type TrialAWebDto = {
  __typename?: 'TrialAWebDto';
  /** Отчет кандидата */
  candidateReportFiles?: Maybe<Array<TrialFileAWebDto>>;
  /** Комментарий к тестированию */
  comment?: Maybe<Scalars['String']['output']>;
  /** Кандидат */
  companyCandidate: CompanyCandidateAWebDto;
  /** ID Кандидата компании */
  companyCandidateId: Scalars['ID']['output'];
  /** Дата завершения тестирования */
  completedAt?: Maybe<Scalars['Date']['output']>;
  /** Карта компетенций */
  examination: ExaminationAWebDto;
  /** Id типа тестирования */
  examinationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Завершено ли тестирование */
  isAssessmentComplete: Scalars['Boolean']['output'];
  /** Числовой id тестирования */
  numericId: Scalars['Float']['output'];
  /** Список вопросов */
  questionList?: Maybe<Array<TrialQuestionListElement>>;
  /** Генерировать вопросы картинкой */
  questionsAsImage: Scalars['Boolean']['output'];
  /** Id сессии интервью */
  sessionId?: Maybe<Scalars['ID']['output']>;
  /** Статус тестирования */
  status: Trial_Status;
  /** Ответы */
  trialAnswers?: Maybe<Array<TrialAnswerAWebDto>>;
  /** Результаты проверки репозитория */
  trialRepositoryChecks: Array<TrialRepositoryCheckAWebDto>;
};

export type TrialAnswer = {
  __typename?: 'TrialAnswer';
  /** Логи оценки ответа */
  MlLogs?: Maybe<Array<MlLog>>;
  /** Дополнительный вопрос */
  additionalQuestion?: Maybe<Scalars['String']['output']>;
  /** Ответ на вопрос */
  answer?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Вердикт ответа */
  criterionAssessments?: Maybe<Array<CriterionAssessment>>;
  /** Файл голосового ответа */
  file?: Maybe<File>;
  /** ID файла голосового ответа */
  fileId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Пропущен ли вопрос */
  isSkipped: Scalars['Boolean']['output'];
  /** Дополнительные данные об ответе */
  metadata?: Maybe<TrialAnswerMetadata>;
  /** Вердикт микрокритерия */
  microcriterionAssessments?: Maybe<Array<CriterionAssessment>>;
  /** Оценка микрокритерия */
  microcriterionScore?: Maybe<Scalars['Float']['output']>;
  /** Ответ на вопрос с вариантами ответа */
  partsIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Вопрос */
  question: Question;
  /** ID вопроса */
  questionId: Scalars['ID']['output'];
  /** Оценка ответа */
  score?: Maybe<Scalars['Float']['output']>;
  /** Количество секунд затраченных на ответ */
  time: Scalars['Float']['output'];
  /** Тестирование */
  trial: Trial;
  /** ID Тестирования */
  trialId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type TrialAnswerAWebDto = {
  __typename?: 'TrialAnswerAWebDto';
  /** Ответ на вопрос */
  answer?: Maybe<Scalars['String']['output']>;
  /** Вердикт ответа */
  criterionAssessments?: Maybe<Array<CriterionAssessment>>;
  /** Файл аудио ответа */
  file?: Maybe<FileAWebDto>;
  /** ID файла голосового ответа */
  fileId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** Вердикт микрокритерия */
  microcriterionAssessments?: Maybe<Array<CriterionAssessment>>;
  /** Оценка микрокритерия */
  microcriterionScore?: Maybe<Scalars['Float']['output']>;
  /** Ответ на вопрос с вариантами ответа */
  partsIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Вопрос */
  question: QuestionAWebDto;
  /** ID вопроса */
  questionId: Scalars['ID']['output'];
  /** Оценка ответа */
  score?: Maybe<Scalars['Float']['output']>;
  /** Количество секунд затраченных на ответ */
  time: Scalars['Float']['output'];
  /** Тестирование */
  trial: TrialAWebDto;
  /** ID Тестирования */
  trialId: Scalars['ID']['output'];
};

export type TrialAnswerMetadata = {
  __typename?: 'TrialAnswerMetadata';
  insertCount?: Maybe<Scalars['Float']['output']>;
  insertSymbols?: Maybe<Scalars['Float']['output']>;
};

export type TrialFile = {
  __typename?: 'TrialFile';
  createdAt: Scalars['Date']['output'];
  /** Данные файла */
  file: File;
  /** ID файла */
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Тестирование */
  trial: Trial;
  /** ID тестирования */
  trialId: Scalars['ID']['output'];
  /** Тип отчета */
  type: Trial_File_Type;
  updatedAt: Scalars['Date']['output'];
};

export type TrialFileAWebDto = {
  __typename?: 'TrialFileAWebDto';
  /** Вопрос */
  file: FileAWebDto;
  /** ID файла */
  fileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Тестирование */
  trial: TrialAWebDto;
  /** ID тестирования */
  trialId: Scalars['ID']['output'];
  /** Тип отчета */
  type: Trial_File_Type;
};

export type TrialInfoAWebDto = {
  __typename?: 'TrialInfoAWebDto';
  /** Отчет кандидата */
  candidateReportFiles?: Maybe<Array<TrialFileAWebDto>>;
  /** Комментарий к тестированию */
  comment?: Maybe<Scalars['String']['output']>;
  /** Кандидат */
  companyCandidate: CompanyCandidateAWebDto;
  /** ID Кандидата компании */
  companyCandidateId: Scalars['ID']['output'];
  /** Дата завершения тестирования */
  completedAt?: Maybe<Scalars['Date']['output']>;
  /** Карта компетенций */
  examination: ExaminationAWebDto;
  /** Id типа тестирования */
  examinationId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Завершено ли тестирование */
  isAssessmentComplete: Scalars['Boolean']['output'];
  /** Числовой id тестирования */
  numericId: Scalars['Float']['output'];
  /** Список вопросов */
  questionList?: Maybe<Array<TrialQuestionListElement>>;
  /** Генерировать вопросы картинкой */
  questionsAsImage: Scalars['Boolean']['output'];
  /** Id сессии интервью */
  sessionId?: Maybe<Scalars['ID']['output']>;
  /** Статус тестирования */
  status: Trial_Status;
  /** Общее время тестирования */
  totalTime: Scalars['Float']['output'];
  /** Ответы */
  trialAnswers?: Maybe<Array<TrialAnswerAWebDto>>;
  /** Результаты проверки репозитория */
  trialRepositoryChecks: Array<TrialRepositoryCheckAWebDto>;
};

export type TrialQuestionListElement = {
  __typename?: 'TrialQuestionListElement';
  /** Текс дополнительного вопроса */
  additionalQuestion?: Maybe<Scalars['String']['output']>;
  /** Количество секунд затраченных кандидатом */
  candidateTime?: Maybe<Scalars['Float']['output']>;
  /** Порядковый номер в тестировании */
  order: Scalars['Float']['output'];
  /** Критерии для дополнительного вопроса */
  pendingCriterion?: Maybe<Array<Scalars['String']['output']>>;
  /** Id вопроса */
  questionId: Scalars['ID']['output'];
  /** Статус вопроса */
  status: Trial_Question_Status;
  /** Количество секунд отведённых на вопрос */
  time: Scalars['Float']['output'];
};

export type TrialReportData = {
  __typename?: 'TrialReportData';
  ai_generation_competencies?: Maybe<Array<Scalars['String']['output']>>;
  ai_generation_percentage?: Maybe<Scalars['Float']['output']>;
  competencies?: Maybe<Scalars['JSON']['output']>;
  development_recommendations?: Maybe<Array<Scalars['String']['output']>>;
  employee_comment?: Maybe<Scalars['String']['output']>;
  general_summary?: Maybe<Array<Scalars['String']['output']>>;
  hr_comment?: Maybe<Scalars['String']['output']>;
};

export type TrialRepositoryCheck = {
  __typename?: 'TrialRepositoryCheck';
  /** Балл за алгоритмы */
  algorithmsScore?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Ошибка API проверки репозитория */
  error?: Maybe<Scalars['JSON']['output']>;
  /** Факты о репозитории */
  facts?: Maybe<TrialRepositoryFacts>;
  id: Scalars['ID']['output'];
  /** Балл за поддерживаемость */
  maintainabilityScore?: Maybe<Scalars['Float']['output']>;
  /** Основной язык репозитория */
  programingLanguage?: Maybe<Scalars['String']['output']>;
  /** Балл за читаемость */
  readabilityScore?: Maybe<Scalars['Float']['output']>;
  /** Ссылка на репозиторий */
  repoUrl?: Maybe<Scalars['String']['output']>;
  /** ID в API проверки репозитория */
  taskId?: Maybe<Scalars['ID']['output']>;
  /** Общий балл */
  totalScore?: Maybe<Scalars['Float']['output']>;
  /** Тестирование */
  trial: Trial;
  /** ID Тестирования */
  trialId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type TrialRepositoryCheckAWebDto = {
  __typename?: 'TrialRepositoryCheckAWebDto';
  /** Балл за алгоритмы */
  algorithmsScore?: Maybe<Scalars['Float']['output']>;
  /** Ошибка API проверки репозитория */
  error?: Maybe<Scalars['JSON']['output']>;
  /** Факты о репозитории */
  facts?: Maybe<TrialRepositoryFacts>;
  /** Балл за поддерживаемость */
  maintainabilityScore?: Maybe<Scalars['Float']['output']>;
  /** Основной язык репозитория */
  programingLanguage?: Maybe<Scalars['String']['output']>;
  /** Балл за читаемость */
  readabilityScore?: Maybe<Scalars['Float']['output']>;
  /** Ссылка на репозиторий */
  repoUrl?: Maybe<Scalars['String']['output']>;
  /** Общий балл */
  totalScore?: Maybe<Scalars['Float']['output']>;
  /** Тестирование */
  trial: TrialAWebDto;
  /** ID Тестирования */
  trialId: Scalars['ID']['output'];
};

export type TrialRepositoryFacts = {
  __typename?: 'TrialRepositoryFacts';
  developers_count?: Maybe<Scalars['Float']['output']>;
  first_release_date?: Maybe<Scalars['Date']['output']>;
  forks_count?: Maybe<Scalars['Float']['output']>;
  is_scoring_available?: Maybe<Scalars['Boolean']['output']>;
  languages?: Maybe<Scalars['JSON']['output']>;
  main_language?: Maybe<Scalars['String']['output']>;
  repo_url?: Maybe<Scalars['String']['output']>;
  stars_count?: Maybe<Scalars['Float']['output']>;
};

export type TrialStatusHistory = {
  __typename?: 'TrialStatusHistory';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Новый статус тестирования */
  newStatus: Trial_Status;
  /** Тестирование */
  trial: Trial;
  /** ID Тестирования */
  trialId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type UpdateFirstCreatedCompaniesInput = {
  /** Почта кандидата компании */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ФИО кандидата компании */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Ссылка на headhunter */
  link?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  /** Соглашение на обработку персональных данных */
  agreement: Scalars['Boolean']['output'];
  createdAt: Scalars['Date']['output'];
  /** Имя пользователя */
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Является ли пользователь админом */
  isAdmin: Scalars['Boolean']['output'];
  /** Заблокирован ли пользователь */
  isBlocked: Scalars['Boolean']['output'];
  /** Фамилия пользователя */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Отчество пользователя */
  middleName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  /** Eмail пользователя */
  userEmail: UserEmail;
  /** ID email пользователя */
  userEmailId: Scalars['ID']['output'];
};

export type UserEmail = {
  __typename?: 'UserEmail';
  /** Пользователи компании */
  companyUsers?: Maybe<Array<CompanyUser>>;
  createdAt: Scalars['Date']['output'];
  /** Email пользователя */
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Пользователь */
  user: User;
};

export type Vacancy = {
  __typename?: 'Vacancy';
  /** Компания */
  company: Company;
  /** Id компании */
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  /** Описание вакансии */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Численный id в рамках компании */
  numericId: Scalars['Float']['output'];
  /** Название вакансии */
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Оценки CV кандидатов */
  vacancyCompanyCandidates?: Maybe<Array<VacancyCompanyCandidate>>;
};

export type VacancyCompanyCandidate = {
  __typename?: 'VacancyCompanyCandidate';
  /** Кандидат компании */
  companyCandidate: CompanyCandidate;
  /** Id кандидата компании */
  companyCandidateId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  /** История проверок CV кандидатов */
  cvChecks?: Maybe<Array<CvCheck>>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Вакансия */
  vacancy: Vacancy;
  /** Id вакансии */
  vacancyId: Scalars['ID']['output'];
};

export type CancelTrialMutationVariables = Exact<{
  trialId: Scalars['String']['input'];
}>;

export type CancelTrialMutation = {
  __typename?: 'Mutation';
  cancelTrial: { __typename?: 'TrialAWebDto'; id: string };
};

export type CreateTrialForOpenedExaminationMutationVariables = Exact<{
  examinationId: Scalars['String']['input'];
}>;

export type CreateTrialForOpenedExaminationMutation = {
  __typename?: 'Mutation';
  createTrialForOpenedExamination: { __typename?: 'TrialAWebDto'; id: string };
};

export type DelayQuestionMutationVariables = Exact<{
  input: QuestionForTrialActionInput;
}>;

export type DelayQuestionMutation = {
  __typename?: 'Mutation';
  delayQuestion: Array<{
    __typename?: 'TrialQuestionListElement';
    questionId: string;
    candidateTime?: number | null;
  }>;
};

export type GenerateReportFileMutationVariables = Exact<{
  input: GenerateReportFileInput;
}>;

export type GenerateReportFileMutation = {
  __typename?: 'Mutation';
  generateReportFile?: {
    __typename?: 'TrialFileAWebDto';
    id: string;
    type: Trial_File_Type;
    trialId: string;
    file: { __typename?: 'FileAWebDto'; id: string; name: string; url: string };
  } | null;
};

export type InterviewSendAnswerMutationVariables = Exact<{
  input: InterviewSendAnswerInput;
}>;

export type InterviewSendAnswerMutation = { __typename?: 'Mutation'; interviewSendAnswer: boolean };

export type SaveAnswerMutationVariables = Exact<{
  input: SaveAnswerInput;
}>;

export type SaveAnswerMutation = { __typename?: 'Mutation'; saveAnswer: boolean };

export type SkipQuestionMutationVariables = Exact<{
  input: QuestionForTrialActionInput;
}>;

export type SkipQuestionMutation = {
  __typename?: 'Mutation';
  skipQuestion: Array<{
    __typename?: 'TrialQuestionListElement';
    questionId: string;
    candidateTime?: number | null;
  }>;
};

export type SpeechToTextMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;

export type SpeechToTextMutation = { __typename?: 'Mutation'; speechToText: string };

export type StartQuestionMutationVariables = Exact<{
  input: QuestionForTrialInput;
}>;

export type StartQuestionMutation = {
  __typename?: 'Mutation';
  startQuestion: {
    __typename?: 'StartQuestionAWebDto';
    id: string;
    time: number;
    text: string;
    type: Question_Type;
    correctCountType?: Question_Correct_Count_Type | null;
    parts?: Array<{ __typename?: 'QuestionPartAWebDto'; id: string; content: string }> | null;
  };
};

export type StartTrialMutationVariables = Exact<{
  trialId: Scalars['String']['input'];
}>;

export type StartTrialMutation = {
  __typename?: 'Mutation';
  startTrial: {
    __typename?: 'TrialAWebDto';
    id: string;
    status: Trial_Status;
    sessionId?: string | null;
  };
};

export type SuspendTrialMutationVariables = Exact<{
  trialId: Scalars['String']['input'];
}>;

export type SuspendTrialMutation = {
  __typename?: 'Mutation';
  suspendTrial: {
    __typename?: 'TrialAWebDto';
    id: string;
    status: Trial_Status;
    sessionId?: string | null;
  };
};

export type InterviewCurrentMessagesQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;

export type InterviewCurrentMessagesQuery = {
  __typename?: 'Query';
  interviewCurrentMessages: Array<{
    __typename?: 'InterviewReplyMessage';
    content: string;
    event: Interview_Reply_Event;
  }>;
};

export type IsExaminationActiveQueryVariables = Exact<{
  examinationId: Scalars['String']['input'];
}>;

export type IsExaminationActiveQuery = { __typename?: 'Query'; isExaminationActive: boolean };

export type TrialInfoQueryVariables = Exact<{
  trialId: Scalars['String']['input'];
}>;

export type TrialInfoQuery = {
  __typename?: 'Query';
  trialInfo: {
    __typename?: 'TrialInfoAWebDto';
    id: string;
    status: Trial_Status;
    totalTime: number;
    sessionId?: string | null;
    examination: {
      __typename?: 'ExaminationAWebDto';
      id: string;
      isInterview: boolean;
      isSendResult: boolean;
      competencyMap: {
        __typename?: 'CompetencyMapAWebDto';
        id: string;
        title: string;
        specialization: string;
      };
    };
    questionList?: Array<{
      __typename?: 'TrialQuestionListElement';
      questionId: string;
      status: Trial_Question_Status;
      time: number;
      order: number;
      candidateTime?: number | null;
    }> | null;
  };
};

export type TrialsQueryVariables = Exact<{
  filter: ListTrialFilterInput;
  limit: Scalars['Float']['input'];
  order: AssessmentWebTrialListOrderInput;
  page: Scalars['Float']['input'];
}>;

export type TrialsQuery = {
  __typename?: 'Query';
  trials: {
    __typename?: 'PaginatedTrialAWebDto';
    totalCount: number;
    data?: Array<{
      __typename?: 'TrialAWebDto';
      id: string;
      status: Trial_Status;
      completedAt?: any | null;
      isAssessmentComplete: boolean;
      candidateReportFiles?: Array<{
        __typename?: 'TrialFileAWebDto';
        id: string;
        file: { __typename?: 'FileAWebDto'; id: string; url: string };
      }> | null;
      examination: {
        __typename?: 'ExaminationAWebDto';
        id: string;
        isSendResult: boolean;
        competencyMap: { __typename?: 'CompetencyMapAWebDto'; id: string; title: string };
      };
      companyCandidate: {
        __typename?: 'CompanyCandidateAWebDto';
        id: string;
        fullName: string;
        company: { __typename?: 'CompanyAWebDto'; id: string; shortName: string };
      };
    }> | null;
  };
};

export type InterviewReplySubscriptionVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;

export type InterviewReplySubscription = {
  __typename?: 'Subscription';
  interviewReply?: {
    __typename?: 'InterviewReplyMessage';
    content: string;
    event: Interview_Reply_Event;
  } | null;
};

export type ConfirmEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type ConfirmEmailMutation = { __typename?: 'Mutation'; confirmEmail: boolean };

export type InitConfirmEmailMutationVariables = Exact<{ [key: string]: never }>;

export type InitConfirmEmailMutation = { __typename?: 'Mutation'; initConfirmEmail: boolean };

export type InitResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type InitResetPasswordMutation = { __typename?: 'Mutation'; initResetPassword: boolean };

export type LoginByEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type LoginByEmailMutation = {
  __typename?: 'Mutation';
  loginByEmail: {
    __typename?: 'AuthCandidateTokensDto';
    accessToken: string;
    refreshToken: string;
  };
};

export type LoginByLoginMutationVariables = Exact<{
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type LoginByLoginMutation = {
  __typename?: 'Mutation';
  loginByLogin: {
    __typename?: 'AuthCandidateTokensDto';
    accessToken: string;
    refreshToken: string;
  };
};

export type LoginBySocialNetworkMutationVariables = Exact<{
  input: AuthBySocialNetworkInput;
}>;

export type LoginBySocialNetworkMutation = {
  __typename?: 'Mutation';
  loginBySocialNetwork: {
    __typename?: 'AuthCandidateTokensDto';
    accessToken: string;
    refreshToken: string;
  };
};

export type LoginByTelegramTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type LoginByTelegramTokenMutation = {
  __typename?: 'Mutation';
  loginByTelegramToken: {
    __typename?: 'AuthCandidateTokensDto';
    accessToken: string;
    refreshToken: string;
  };
};

export type LoginByTelegramWebAppTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type LoginByTelegramWebAppTokenMutation = {
  __typename?: 'Mutation';
  loginByTelegramWebAppToken: {
    __typename?: 'AuthCandidateTokensDto';
    refreshToken: string;
    accessToken: string;
  };
};

export type RefreshTokensMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;

export type RefreshTokensMutation = {
  __typename?: 'Mutation';
  refreshTokens: {
    __typename?: 'AuthCandidateTokensDto';
    accessToken: string;
    refreshToken: string;
  };
};

export type RegisterByEmailMutationVariables = Exact<{
  input: RegisterCandidateEmailInput;
}>;

export type RegisterByEmailMutation = {
  __typename?: 'Mutation';
  registerByEmail: {
    __typename?: 'AuthCandidateTokensDto';
    accessToken: string;
    refreshToken: string;
  };
};

export type RegisterCandidateByPublicExaminationMutationVariables = Exact<{
  input: RegisterCandidateByPublicExaminationInput;
}>;

export type RegisterCandidateByPublicExaminationMutation = {
  __typename?: 'Mutation';
  registerCandidateByPublicExamination: {
    __typename?: 'AuthCandidateTokensDto';
    accessToken: string;
    refreshToken: string;
  };
};

export type ResetPasswordMutationVariables = Exact<{
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type ResetPasswordMutation = { __typename?: 'Mutation'; resetPassword: boolean };

export type SendBugReportMutationVariables = Exact<{
  input: SendBugReportInput;
}>;

export type SendBugReportMutation = { __typename?: 'Mutation'; sendBugReport: boolean };

export type SetCandidateAgreementTrueMutationVariables = Exact<{ [key: string]: never }>;

export type SetCandidateAgreementTrueMutation = {
  __typename?: 'Mutation';
  setCandidateAgreementTrue: { __typename?: 'CandidateAWebDto'; id: string; agreement: boolean };
};

export type SetCandidateLanguageMutationVariables = Exact<{
  language: Language;
}>;

export type SetCandidateLanguageMutation = {
  __typename?: 'Mutation';
  setCandidateLanguage: {
    __typename?: 'CandidateAWebDto';
    id: string;
    language?: Language | null;
    agreement: boolean;
    phoneNumber?: string | null;
    candidateUsername: {
      __typename?: 'CandidateUsernameAWebDto';
      id: string;
      login?: string | null;
    };
  };
};

export type SetCandidatePhoneNumberMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;

export type SetCandidatePhoneNumberMutation = {
  __typename?: 'Mutation';
  setCandidatePhoneNumber: {
    __typename?: 'CandidateAWebDto';
    id: string;
    phoneNumber?: string | null;
  };
};

export type LinkEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type LinkEmailMutation = {
  __typename?: 'Mutation';
  linkEmail: {
    __typename?: 'CandidateAWebDto';
    id: string;
    candidateUsername: {
      __typename?: 'CandidateUsernameAWebDto';
      id: string;
      email?: string | null;
      emailIsConfirmed?: boolean | null;
    };
  };
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'CandidateAWebDto';
    id: string;
    phoneNumber?: string | null;
    language?: Language | null;
    agreement: boolean;
    fullName?: string | null;
    candidateUsername: {
      __typename?: 'CandidateUsernameAWebDto';
      id: string;
      login?: string | null;
      email?: string | null;
      emailIsConfirmed?: boolean | null;
    };
    firstCompanyCandidate?: {
      __typename?: 'CompanyCandidateAWebDto';
      id: string;
      fullName: string;
    } | null;
  };
};

export type GetUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'CandidateAWebDto';
    id: string;
    phoneNumber?: string | null;
    language?: Language | null;
    fullName?: string | null;
    candidateUsername: {
      __typename?: 'CandidateUsernameAWebDto';
      id: string;
      telegramUsername?: string | null;
      yandexEmail?: string | null;
      email?: string | null;
      emailIsConfirmed?: boolean | null;
    };
    firstCompanyCandidate?: {
      __typename?: 'CompanyCandidateAWebDto';
      id: string;
      fullName: string;
      position?: string | null;
      organization?: string | null;
      email?: string | null;
    } | null;
  };
};

export type UpdateFirstCompanyCandidateMutationVariables = Exact<{
  firstCompanyCandidate: UpdateFirstCreatedCompaniesInput;
}>;

export type UpdateFirstCompanyCandidateMutation = {
  __typename?: 'Mutation';
  updateFirstCompanyCandidate: {
    __typename?: 'CompanyCandidateAWebDto';
    id: string;
    email?: string | null;
    fullName: string;
  };
};

export const CancelTrialDocument = gql`
  mutation cancelTrial($trialId: String!) {
    cancelTrial(trialId: $trialId) {
      id
    }
  }
`;
export type CancelTrialMutationFn = Apollo.MutationFunction<
  CancelTrialMutation,
  CancelTrialMutationVariables
>;

/**
 * __useCancelTrialMutation__
 *
 * To run a mutation, you first call `useCancelTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTrialMutation, { data, loading, error }] = useCancelTrialMutation({
 *   variables: {
 *      trialId: // value for 'trialId'
 *   },
 * });
 */
export function useCancelTrialMutation(
  baseOptions?: Apollo.MutationHookOptions<CancelTrialMutation, CancelTrialMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelTrialMutation, CancelTrialMutationVariables>(
    CancelTrialDocument,
    options,
  );
}
export type CancelTrialMutationHookResult = ReturnType<typeof useCancelTrialMutation>;
export type CancelTrialMutationResult = Apollo.MutationResult<CancelTrialMutation>;
export type CancelTrialMutationOptions = Apollo.BaseMutationOptions<
  CancelTrialMutation,
  CancelTrialMutationVariables
>;
export const CreateTrialForOpenedExaminationDocument = gql`
  mutation createTrialForOpenedExamination($examinationId: String!) {
    createTrialForOpenedExamination(examinationId: $examinationId) {
      id
    }
  }
`;
export type CreateTrialForOpenedExaminationMutationFn = Apollo.MutationFunction<
  CreateTrialForOpenedExaminationMutation,
  CreateTrialForOpenedExaminationMutationVariables
>;

/**
 * __useCreateTrialForOpenedExaminationMutation__
 *
 * To run a mutation, you first call `useCreateTrialForOpenedExaminationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrialForOpenedExaminationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrialForOpenedExaminationMutation, { data, loading, error }] = useCreateTrialForOpenedExaminationMutation({
 *   variables: {
 *      examinationId: // value for 'examinationId'
 *   },
 * });
 */
export function useCreateTrialForOpenedExaminationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTrialForOpenedExaminationMutation,
    CreateTrialForOpenedExaminationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTrialForOpenedExaminationMutation,
    CreateTrialForOpenedExaminationMutationVariables
  >(CreateTrialForOpenedExaminationDocument, options);
}
export type CreateTrialForOpenedExaminationMutationHookResult = ReturnType<
  typeof useCreateTrialForOpenedExaminationMutation
>;
export type CreateTrialForOpenedExaminationMutationResult =
  Apollo.MutationResult<CreateTrialForOpenedExaminationMutation>;
export type CreateTrialForOpenedExaminationMutationOptions = Apollo.BaseMutationOptions<
  CreateTrialForOpenedExaminationMutation,
  CreateTrialForOpenedExaminationMutationVariables
>;
export const DelayQuestionDocument = gql`
  mutation delayQuestion($input: QuestionForTrialActionInput!) {
    delayQuestion(input: $input) {
      questionId
      candidateTime
    }
  }
`;
export type DelayQuestionMutationFn = Apollo.MutationFunction<
  DelayQuestionMutation,
  DelayQuestionMutationVariables
>;

/**
 * __useDelayQuestionMutation__
 *
 * To run a mutation, you first call `useDelayQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelayQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [delayQuestionMutation, { data, loading, error }] = useDelayQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDelayQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<DelayQuestionMutation, DelayQuestionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DelayQuestionMutation, DelayQuestionMutationVariables>(
    DelayQuestionDocument,
    options,
  );
}
export type DelayQuestionMutationHookResult = ReturnType<typeof useDelayQuestionMutation>;
export type DelayQuestionMutationResult = Apollo.MutationResult<DelayQuestionMutation>;
export type DelayQuestionMutationOptions = Apollo.BaseMutationOptions<
  DelayQuestionMutation,
  DelayQuestionMutationVariables
>;
export const GenerateReportFileDocument = gql`
  mutation generateReportFile($input: GenerateReportFileInput!) {
    generateReportFile(input: $input) {
      id
      type
      trialId
      file {
        id
        name
        url
      }
    }
  }
`;
export type GenerateReportFileMutationFn = Apollo.MutationFunction<
  GenerateReportFileMutation,
  GenerateReportFileMutationVariables
>;

/**
 * __useGenerateReportFileMutation__
 *
 * To run a mutation, you first call `useGenerateReportFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportFileMutation, { data, loading, error }] = useGenerateReportFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateReportFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateReportFileMutation,
    GenerateReportFileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GenerateReportFileMutation, GenerateReportFileMutationVariables>(
    GenerateReportFileDocument,
    options,
  );
}
export type GenerateReportFileMutationHookResult = ReturnType<typeof useGenerateReportFileMutation>;
export type GenerateReportFileMutationResult = Apollo.MutationResult<GenerateReportFileMutation>;
export type GenerateReportFileMutationOptions = Apollo.BaseMutationOptions<
  GenerateReportFileMutation,
  GenerateReportFileMutationVariables
>;
export const InterviewSendAnswerDocument = gql`
  mutation interviewSendAnswer($input: InterviewSendAnswerInput!) {
    interviewSendAnswer(input: $input)
  }
`;
export type InterviewSendAnswerMutationFn = Apollo.MutationFunction<
  InterviewSendAnswerMutation,
  InterviewSendAnswerMutationVariables
>;

/**
 * __useInterviewSendAnswerMutation__
 *
 * To run a mutation, you first call `useInterviewSendAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewSendAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewSendAnswerMutation, { data, loading, error }] = useInterviewSendAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewSendAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InterviewSendAnswerMutation,
    InterviewSendAnswerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InterviewSendAnswerMutation, InterviewSendAnswerMutationVariables>(
    InterviewSendAnswerDocument,
    options,
  );
}
export type InterviewSendAnswerMutationHookResult = ReturnType<
  typeof useInterviewSendAnswerMutation
>;
export type InterviewSendAnswerMutationResult = Apollo.MutationResult<InterviewSendAnswerMutation>;
export type InterviewSendAnswerMutationOptions = Apollo.BaseMutationOptions<
  InterviewSendAnswerMutation,
  InterviewSendAnswerMutationVariables
>;
export const SaveAnswerDocument = gql`
  mutation saveAnswer($input: SaveAnswerInput!) {
    saveAnswer(input: $input)
  }
`;
export type SaveAnswerMutationFn = Apollo.MutationFunction<
  SaveAnswerMutation,
  SaveAnswerMutationVariables
>;

/**
 * __useSaveAnswerMutation__
 *
 * To run a mutation, you first call `useSaveAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAnswerMutation, { data, loading, error }] = useSaveAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<SaveAnswerMutation, SaveAnswerMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SaveAnswerMutation, SaveAnswerMutationVariables>(
    SaveAnswerDocument,
    options,
  );
}
export type SaveAnswerMutationHookResult = ReturnType<typeof useSaveAnswerMutation>;
export type SaveAnswerMutationResult = Apollo.MutationResult<SaveAnswerMutation>;
export type SaveAnswerMutationOptions = Apollo.BaseMutationOptions<
  SaveAnswerMutation,
  SaveAnswerMutationVariables
>;
export const SkipQuestionDocument = gql`
  mutation skipQuestion($input: QuestionForTrialActionInput!) {
    skipQuestion(input: $input) {
      questionId
      candidateTime
    }
  }
`;
export type SkipQuestionMutationFn = Apollo.MutationFunction<
  SkipQuestionMutation,
  SkipQuestionMutationVariables
>;

/**
 * __useSkipQuestionMutation__
 *
 * To run a mutation, you first call `useSkipQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipQuestionMutation, { data, loading, error }] = useSkipQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkipQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<SkipQuestionMutation, SkipQuestionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SkipQuestionMutation, SkipQuestionMutationVariables>(
    SkipQuestionDocument,
    options,
  );
}
export type SkipQuestionMutationHookResult = ReturnType<typeof useSkipQuestionMutation>;
export type SkipQuestionMutationResult = Apollo.MutationResult<SkipQuestionMutation>;
export type SkipQuestionMutationOptions = Apollo.BaseMutationOptions<
  SkipQuestionMutation,
  SkipQuestionMutationVariables
>;
export const SpeechToTextDocument = gql`
  mutation speechToText($file: Upload!) {
    speechToText(file: $file)
  }
`;
export type SpeechToTextMutationFn = Apollo.MutationFunction<
  SpeechToTextMutation,
  SpeechToTextMutationVariables
>;

/**
 * __useSpeechToTextMutation__
 *
 * To run a mutation, you first call `useSpeechToTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSpeechToTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [speechToTextMutation, { data, loading, error }] = useSpeechToTextMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useSpeechToTextMutation(
  baseOptions?: Apollo.MutationHookOptions<SpeechToTextMutation, SpeechToTextMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SpeechToTextMutation, SpeechToTextMutationVariables>(
    SpeechToTextDocument,
    options,
  );
}
export type SpeechToTextMutationHookResult = ReturnType<typeof useSpeechToTextMutation>;
export type SpeechToTextMutationResult = Apollo.MutationResult<SpeechToTextMutation>;
export type SpeechToTextMutationOptions = Apollo.BaseMutationOptions<
  SpeechToTextMutation,
  SpeechToTextMutationVariables
>;
export const StartQuestionDocument = gql`
  mutation startQuestion($input: QuestionForTrialInput!) {
    startQuestion(input: $input) {
      id
      time
      text
      type
      correctCountType
      parts {
        id
        content
      }
    }
  }
`;
export type StartQuestionMutationFn = Apollo.MutationFunction<
  StartQuestionMutation,
  StartQuestionMutationVariables
>;

/**
 * __useStartQuestionMutation__
 *
 * To run a mutation, you first call `useStartQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startQuestionMutation, { data, loading, error }] = useStartQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<StartQuestionMutation, StartQuestionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartQuestionMutation, StartQuestionMutationVariables>(
    StartQuestionDocument,
    options,
  );
}
export type StartQuestionMutationHookResult = ReturnType<typeof useStartQuestionMutation>;
export type StartQuestionMutationResult = Apollo.MutationResult<StartQuestionMutation>;
export type StartQuestionMutationOptions = Apollo.BaseMutationOptions<
  StartQuestionMutation,
  StartQuestionMutationVariables
>;
export const StartTrialDocument = gql`
  mutation startTrial($trialId: String!) {
    startTrial(trialId: $trialId) {
      id
      status
      sessionId
    }
  }
`;
export type StartTrialMutationFn = Apollo.MutationFunction<
  StartTrialMutation,
  StartTrialMutationVariables
>;

/**
 * __useStartTrialMutation__
 *
 * To run a mutation, you first call `useStartTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTrialMutation, { data, loading, error }] = useStartTrialMutation({
 *   variables: {
 *      trialId: // value for 'trialId'
 *   },
 * });
 */
export function useStartTrialMutation(
  baseOptions?: Apollo.MutationHookOptions<StartTrialMutation, StartTrialMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartTrialMutation, StartTrialMutationVariables>(
    StartTrialDocument,
    options,
  );
}
export type StartTrialMutationHookResult = ReturnType<typeof useStartTrialMutation>;
export type StartTrialMutationResult = Apollo.MutationResult<StartTrialMutation>;
export type StartTrialMutationOptions = Apollo.BaseMutationOptions<
  StartTrialMutation,
  StartTrialMutationVariables
>;
export const SuspendTrialDocument = gql`
  mutation suspendTrial($trialId: String!) {
    suspendTrial(trialId: $trialId) {
      id
      status
      sessionId
    }
  }
`;
export type SuspendTrialMutationFn = Apollo.MutationFunction<
  SuspendTrialMutation,
  SuspendTrialMutationVariables
>;

/**
 * __useSuspendTrialMutation__
 *
 * To run a mutation, you first call `useSuspendTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendTrialMutation, { data, loading, error }] = useSuspendTrialMutation({
 *   variables: {
 *      trialId: // value for 'trialId'
 *   },
 * });
 */
export function useSuspendTrialMutation(
  baseOptions?: Apollo.MutationHookOptions<SuspendTrialMutation, SuspendTrialMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SuspendTrialMutation, SuspendTrialMutationVariables>(
    SuspendTrialDocument,
    options,
  );
}
export type SuspendTrialMutationHookResult = ReturnType<typeof useSuspendTrialMutation>;
export type SuspendTrialMutationResult = Apollo.MutationResult<SuspendTrialMutation>;
export type SuspendTrialMutationOptions = Apollo.BaseMutationOptions<
  SuspendTrialMutation,
  SuspendTrialMutationVariables
>;
export const InterviewCurrentMessagesDocument = gql`
  query interviewCurrentMessages($sessionId: ID!) {
    interviewCurrentMessages(sessionId: $sessionId) {
      content
      event
    }
  }
`;

/**
 * __useInterviewCurrentMessagesQuery__
 *
 * To run a query within a React component, call `useInterviewCurrentMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewCurrentMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewCurrentMessagesQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useInterviewCurrentMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    InterviewCurrentMessagesQuery,
    InterviewCurrentMessagesQueryVariables
  > &
    ({ variables: InterviewCurrentMessagesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InterviewCurrentMessagesQuery, InterviewCurrentMessagesQueryVariables>(
    InterviewCurrentMessagesDocument,
    options,
  );
}
export function useInterviewCurrentMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InterviewCurrentMessagesQuery,
    InterviewCurrentMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InterviewCurrentMessagesQuery, InterviewCurrentMessagesQueryVariables>(
    InterviewCurrentMessagesDocument,
    options,
  );
}
export function useInterviewCurrentMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InterviewCurrentMessagesQuery,
        InterviewCurrentMessagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    InterviewCurrentMessagesQuery,
    InterviewCurrentMessagesQueryVariables
  >(InterviewCurrentMessagesDocument, options);
}
export type InterviewCurrentMessagesQueryHookResult = ReturnType<
  typeof useInterviewCurrentMessagesQuery
>;
export type InterviewCurrentMessagesLazyQueryHookResult = ReturnType<
  typeof useInterviewCurrentMessagesLazyQuery
>;
export type InterviewCurrentMessagesSuspenseQueryHookResult = ReturnType<
  typeof useInterviewCurrentMessagesSuspenseQuery
>;
export type InterviewCurrentMessagesQueryResult = Apollo.QueryResult<
  InterviewCurrentMessagesQuery,
  InterviewCurrentMessagesQueryVariables
>;
export const IsExaminationActiveDocument = gql`
  query isExaminationActive($examinationId: String!) {
    isExaminationActive(examinationId: $examinationId)
  }
`;

/**
 * __useIsExaminationActiveQuery__
 *
 * To run a query within a React component, call `useIsExaminationActiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsExaminationActiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsExaminationActiveQuery({
 *   variables: {
 *      examinationId: // value for 'examinationId'
 *   },
 * });
 */
export function useIsExaminationActiveQuery(
  baseOptions: Apollo.QueryHookOptions<
    IsExaminationActiveQuery,
    IsExaminationActiveQueryVariables
  > &
    ({ variables: IsExaminationActiveQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IsExaminationActiveQuery, IsExaminationActiveQueryVariables>(
    IsExaminationActiveDocument,
    options,
  );
}
export function useIsExaminationActiveLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsExaminationActiveQuery,
    IsExaminationActiveQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IsExaminationActiveQuery, IsExaminationActiveQueryVariables>(
    IsExaminationActiveDocument,
    options,
  );
}
export function useIsExaminationActiveSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IsExaminationActiveQuery, IsExaminationActiveQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IsExaminationActiveQuery, IsExaminationActiveQueryVariables>(
    IsExaminationActiveDocument,
    options,
  );
}
export type IsExaminationActiveQueryHookResult = ReturnType<typeof useIsExaminationActiveQuery>;
export type IsExaminationActiveLazyQueryHookResult = ReturnType<
  typeof useIsExaminationActiveLazyQuery
>;
export type IsExaminationActiveSuspenseQueryHookResult = ReturnType<
  typeof useIsExaminationActiveSuspenseQuery
>;
export type IsExaminationActiveQueryResult = Apollo.QueryResult<
  IsExaminationActiveQuery,
  IsExaminationActiveQueryVariables
>;
export const TrialInfoDocument = gql`
  query trialInfo($trialId: String!) {
    trialInfo(trialId: $trialId) {
      id
      status
      totalTime
      sessionId
      examination {
        id
        isInterview
        isSendResult
        competencyMap {
          id
          title
          specialization
        }
      }
      questionList {
        questionId
        status
        time
        order
        candidateTime
      }
    }
  }
`;

/**
 * __useTrialInfoQuery__
 *
 * To run a query within a React component, call `useTrialInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialInfoQuery({
 *   variables: {
 *      trialId: // value for 'trialId'
 *   },
 * });
 */
export function useTrialInfoQuery(
  baseOptions: Apollo.QueryHookOptions<TrialInfoQuery, TrialInfoQueryVariables> &
    ({ variables: TrialInfoQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrialInfoQuery, TrialInfoQueryVariables>(TrialInfoDocument, options);
}
export function useTrialInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrialInfoQuery, TrialInfoQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrialInfoQuery, TrialInfoQueryVariables>(TrialInfoDocument, options);
}
export function useTrialInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TrialInfoQuery, TrialInfoQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TrialInfoQuery, TrialInfoQueryVariables>(
    TrialInfoDocument,
    options,
  );
}
export type TrialInfoQueryHookResult = ReturnType<typeof useTrialInfoQuery>;
export type TrialInfoLazyQueryHookResult = ReturnType<typeof useTrialInfoLazyQuery>;
export type TrialInfoSuspenseQueryHookResult = ReturnType<typeof useTrialInfoSuspenseQuery>;
export type TrialInfoQueryResult = Apollo.QueryResult<TrialInfoQuery, TrialInfoQueryVariables>;
export const TrialsDocument = gql`
  query trials(
    $filter: ListTrialFilterInput!
    $limit: Float!
    $order: AssessmentWebTrialListOrderInput!
    $page: Float!
  ) {
    trials(filter: $filter, limit: $limit, page: $page, order: $order) {
      totalCount
      data {
        id
        status
        completedAt
        isAssessmentComplete
        candidateReportFiles {
          id
          file {
            id
            url
          }
        }
        examination {
          id
          isSendResult
          competencyMap {
            id
            title
          }
        }
        companyCandidate {
          id
          fullName
          company {
            id
            shortName
          }
        }
      }
    }
  }
`;

/**
 * __useTrialsQuery__
 *
 * To run a query within a React component, call `useTrialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useTrialsQuery(
  baseOptions: Apollo.QueryHookOptions<TrialsQuery, TrialsQueryVariables> &
    ({ variables: TrialsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TrialsQuery, TrialsQueryVariables>(TrialsDocument, options);
}
export function useTrialsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TrialsQuery, TrialsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TrialsQuery, TrialsQueryVariables>(TrialsDocument, options);
}
export function useTrialsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TrialsQuery, TrialsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TrialsQuery, TrialsQueryVariables>(TrialsDocument, options);
}
export type TrialsQueryHookResult = ReturnType<typeof useTrialsQuery>;
export type TrialsLazyQueryHookResult = ReturnType<typeof useTrialsLazyQuery>;
export type TrialsSuspenseQueryHookResult = ReturnType<typeof useTrialsSuspenseQuery>;
export type TrialsQueryResult = Apollo.QueryResult<TrialsQuery, TrialsQueryVariables>;
export const InterviewReplyDocument = gql`
  subscription interviewReply($sessionId: ID!) {
    interviewReply(sessionId: $sessionId) {
      content
      event
    }
  }
`;

/**
 * __useInterviewReplySubscription__
 *
 * To run a query within a React component, call `useInterviewReplySubscription` and pass it any options that fit your needs.
 * When your component renders, `useInterviewReplySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewReplySubscription({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useInterviewReplySubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    InterviewReplySubscription,
    InterviewReplySubscriptionVariables
  > &
    ({ variables: InterviewReplySubscriptionVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<InterviewReplySubscription, InterviewReplySubscriptionVariables>(
    InterviewReplyDocument,
    options,
  );
}
export type InterviewReplySubscriptionHookResult = ReturnType<typeof useInterviewReplySubscription>;
export type InterviewReplySubscriptionResult =
  Apollo.SubscriptionResult<InterviewReplySubscription>;
export const ConfirmEmailDocument = gql`
  mutation confirmEmail($token: String!) {
    confirmEmail(token: $token)
  }
`;
export type ConfirmEmailMutationFn = Apollo.MutationFunction<
  ConfirmEmailMutation,
  ConfirmEmailMutationVariables
>;

/**
 * __useConfirmEmailMutation__
 *
 * To run a mutation, you first call `useConfirmEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailMutation, { data, loading, error }] = useConfirmEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useConfirmEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(
    ConfirmEmailDocument,
    options,
  );
}
export type ConfirmEmailMutationHookResult = ReturnType<typeof useConfirmEmailMutation>;
export type ConfirmEmailMutationResult = Apollo.MutationResult<ConfirmEmailMutation>;
export type ConfirmEmailMutationOptions = Apollo.BaseMutationOptions<
  ConfirmEmailMutation,
  ConfirmEmailMutationVariables
>;
export const InitConfirmEmailDocument = gql`
  mutation initConfirmEmail {
    initConfirmEmail
  }
`;
export type InitConfirmEmailMutationFn = Apollo.MutationFunction<
  InitConfirmEmailMutation,
  InitConfirmEmailMutationVariables
>;

/**
 * __useInitConfirmEmailMutation__
 *
 * To run a mutation, you first call `useInitConfirmEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitConfirmEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initConfirmEmailMutation, { data, loading, error }] = useInitConfirmEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useInitConfirmEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitConfirmEmailMutation,
    InitConfirmEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InitConfirmEmailMutation, InitConfirmEmailMutationVariables>(
    InitConfirmEmailDocument,
    options,
  );
}
export type InitConfirmEmailMutationHookResult = ReturnType<typeof useInitConfirmEmailMutation>;
export type InitConfirmEmailMutationResult = Apollo.MutationResult<InitConfirmEmailMutation>;
export type InitConfirmEmailMutationOptions = Apollo.BaseMutationOptions<
  InitConfirmEmailMutation,
  InitConfirmEmailMutationVariables
>;
export const InitResetPasswordDocument = gql`
  mutation initResetPassword($email: String!) {
    initResetPassword(email: $email)
  }
`;
export type InitResetPasswordMutationFn = Apollo.MutationFunction<
  InitResetPasswordMutation,
  InitResetPasswordMutationVariables
>;

/**
 * __useInitResetPasswordMutation__
 *
 * To run a mutation, you first call `useInitResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initResetPasswordMutation, { data, loading, error }] = useInitResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInitResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitResetPasswordMutation,
    InitResetPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InitResetPasswordMutation, InitResetPasswordMutationVariables>(
    InitResetPasswordDocument,
    options,
  );
}
export type InitResetPasswordMutationHookResult = ReturnType<typeof useInitResetPasswordMutation>;
export type InitResetPasswordMutationResult = Apollo.MutationResult<InitResetPasswordMutation>;
export type InitResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  InitResetPasswordMutation,
  InitResetPasswordMutationVariables
>;
export const LoginByEmailDocument = gql`
  mutation loginByEmail($email: String!, $password: String!) {
    loginByEmail(email: $email, password: $password) {
      accessToken
      refreshToken
    }
  }
`;
export type LoginByEmailMutationFn = Apollo.MutationFunction<
  LoginByEmailMutation,
  LoginByEmailMutationVariables
>;

/**
 * __useLoginByEmailMutation__
 *
 * To run a mutation, you first call `useLoginByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginByEmailMutation, { data, loading, error }] = useLoginByEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginByEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<LoginByEmailMutation, LoginByEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginByEmailMutation, LoginByEmailMutationVariables>(
    LoginByEmailDocument,
    options,
  );
}
export type LoginByEmailMutationHookResult = ReturnType<typeof useLoginByEmailMutation>;
export type LoginByEmailMutationResult = Apollo.MutationResult<LoginByEmailMutation>;
export type LoginByEmailMutationOptions = Apollo.BaseMutationOptions<
  LoginByEmailMutation,
  LoginByEmailMutationVariables
>;
export const LoginByLoginDocument = gql`
  mutation loginByLogin($login: String!, $password: String!) {
    loginByLogin(login: $login, password: $password) {
      accessToken
      refreshToken
    }
  }
`;
export type LoginByLoginMutationFn = Apollo.MutationFunction<
  LoginByLoginMutation,
  LoginByLoginMutationVariables
>;

/**
 * __useLoginByLoginMutation__
 *
 * To run a mutation, you first call `useLoginByLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginByLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginByLoginMutation, { data, loading, error }] = useLoginByLoginMutation({
 *   variables: {
 *      login: // value for 'login'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginByLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<LoginByLoginMutation, LoginByLoginMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginByLoginMutation, LoginByLoginMutationVariables>(
    LoginByLoginDocument,
    options,
  );
}
export type LoginByLoginMutationHookResult = ReturnType<typeof useLoginByLoginMutation>;
export type LoginByLoginMutationResult = Apollo.MutationResult<LoginByLoginMutation>;
export type LoginByLoginMutationOptions = Apollo.BaseMutationOptions<
  LoginByLoginMutation,
  LoginByLoginMutationVariables
>;
export const LoginBySocialNetworkDocument = gql`
  mutation loginBySocialNetwork($input: AuthBySocialNetworkInput!) {
    loginBySocialNetwork(input: $input) {
      accessToken
      refreshToken
    }
  }
`;
export type LoginBySocialNetworkMutationFn = Apollo.MutationFunction<
  LoginBySocialNetworkMutation,
  LoginBySocialNetworkMutationVariables
>;

/**
 * __useLoginBySocialNetworkMutation__
 *
 * To run a mutation, you first call `useLoginBySocialNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginBySocialNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginBySocialNetworkMutation, { data, loading, error }] = useLoginBySocialNetworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginBySocialNetworkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginBySocialNetworkMutation,
    LoginBySocialNetworkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginBySocialNetworkMutation, LoginBySocialNetworkMutationVariables>(
    LoginBySocialNetworkDocument,
    options,
  );
}
export type LoginBySocialNetworkMutationHookResult = ReturnType<
  typeof useLoginBySocialNetworkMutation
>;
export type LoginBySocialNetworkMutationResult =
  Apollo.MutationResult<LoginBySocialNetworkMutation>;
export type LoginBySocialNetworkMutationOptions = Apollo.BaseMutationOptions<
  LoginBySocialNetworkMutation,
  LoginBySocialNetworkMutationVariables
>;
export const LoginByTelegramTokenDocument = gql`
  mutation loginByTelegramToken($token: String!) {
    loginByTelegramToken(token: $token) {
      accessToken
      refreshToken
    }
  }
`;
export type LoginByTelegramTokenMutationFn = Apollo.MutationFunction<
  LoginByTelegramTokenMutation,
  LoginByTelegramTokenMutationVariables
>;

/**
 * __useLoginByTelegramTokenMutation__
 *
 * To run a mutation, you first call `useLoginByTelegramTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginByTelegramTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginByTelegramTokenMutation, { data, loading, error }] = useLoginByTelegramTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginByTelegramTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginByTelegramTokenMutation,
    LoginByTelegramTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginByTelegramTokenMutation, LoginByTelegramTokenMutationVariables>(
    LoginByTelegramTokenDocument,
    options,
  );
}
export type LoginByTelegramTokenMutationHookResult = ReturnType<
  typeof useLoginByTelegramTokenMutation
>;
export type LoginByTelegramTokenMutationResult =
  Apollo.MutationResult<LoginByTelegramTokenMutation>;
export type LoginByTelegramTokenMutationOptions = Apollo.BaseMutationOptions<
  LoginByTelegramTokenMutation,
  LoginByTelegramTokenMutationVariables
>;
export const LoginByTelegramWebAppTokenDocument = gql`
  mutation loginByTelegramWebAppToken($token: String!) {
    loginByTelegramWebAppToken(token: $token) {
      refreshToken
      accessToken
    }
  }
`;
export type LoginByTelegramWebAppTokenMutationFn = Apollo.MutationFunction<
  LoginByTelegramWebAppTokenMutation,
  LoginByTelegramWebAppTokenMutationVariables
>;

/**
 * __useLoginByTelegramWebAppTokenMutation__
 *
 * To run a mutation, you first call `useLoginByTelegramWebAppTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginByTelegramWebAppTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginByTelegramWebAppTokenMutation, { data, loading, error }] = useLoginByTelegramWebAppTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLoginByTelegramWebAppTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginByTelegramWebAppTokenMutation,
    LoginByTelegramWebAppTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LoginByTelegramWebAppTokenMutation,
    LoginByTelegramWebAppTokenMutationVariables
  >(LoginByTelegramWebAppTokenDocument, options);
}
export type LoginByTelegramWebAppTokenMutationHookResult = ReturnType<
  typeof useLoginByTelegramWebAppTokenMutation
>;
export type LoginByTelegramWebAppTokenMutationResult =
  Apollo.MutationResult<LoginByTelegramWebAppTokenMutation>;
export type LoginByTelegramWebAppTokenMutationOptions = Apollo.BaseMutationOptions<
  LoginByTelegramWebAppTokenMutation,
  LoginByTelegramWebAppTokenMutationVariables
>;
export const RefreshTokensDocument = gql`
  mutation refreshTokens($refreshToken: String!) {
    refreshTokens(refreshToken: $refreshToken) {
      accessToken
      refreshToken
    }
  }
`;
export type RefreshTokensMutationFn = Apollo.MutationFunction<
  RefreshTokensMutation,
  RefreshTokensMutationVariables
>;

/**
 * __useRefreshTokensMutation__
 *
 * To run a mutation, you first call `useRefreshTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokensMutation, { data, loading, error }] = useRefreshTokensMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokensMutation(
  baseOptions?: Apollo.MutationHookOptions<RefreshTokensMutation, RefreshTokensMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RefreshTokensMutation, RefreshTokensMutationVariables>(
    RefreshTokensDocument,
    options,
  );
}
export type RefreshTokensMutationHookResult = ReturnType<typeof useRefreshTokensMutation>;
export type RefreshTokensMutationResult = Apollo.MutationResult<RefreshTokensMutation>;
export type RefreshTokensMutationOptions = Apollo.BaseMutationOptions<
  RefreshTokensMutation,
  RefreshTokensMutationVariables
>;
export const RegisterByEmailDocument = gql`
  mutation registerByEmail($input: RegisterCandidateEmailInput!) {
    registerByEmail(input: $input) {
      accessToken
      refreshToken
    }
  }
`;
export type RegisterByEmailMutationFn = Apollo.MutationFunction<
  RegisterByEmailMutation,
  RegisterByEmailMutationVariables
>;

/**
 * __useRegisterByEmailMutation__
 *
 * To run a mutation, you first call `useRegisterByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerByEmailMutation, { data, loading, error }] = useRegisterByEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterByEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterByEmailMutation,
    RegisterByEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RegisterByEmailMutation, RegisterByEmailMutationVariables>(
    RegisterByEmailDocument,
    options,
  );
}
export type RegisterByEmailMutationHookResult = ReturnType<typeof useRegisterByEmailMutation>;
export type RegisterByEmailMutationResult = Apollo.MutationResult<RegisterByEmailMutation>;
export type RegisterByEmailMutationOptions = Apollo.BaseMutationOptions<
  RegisterByEmailMutation,
  RegisterByEmailMutationVariables
>;
export const RegisterCandidateByPublicExaminationDocument = gql`
  mutation registerCandidateByPublicExamination(
    $input: RegisterCandidateByPublicExaminationInput!
  ) {
    registerCandidateByPublicExamination(input: $input) {
      accessToken
      refreshToken
    }
  }
`;
export type RegisterCandidateByPublicExaminationMutationFn = Apollo.MutationFunction<
  RegisterCandidateByPublicExaminationMutation,
  RegisterCandidateByPublicExaminationMutationVariables
>;

/**
 * __useRegisterCandidateByPublicExaminationMutation__
 *
 * To run a mutation, you first call `useRegisterCandidateByPublicExaminationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterCandidateByPublicExaminationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerCandidateByPublicExaminationMutation, { data, loading, error }] = useRegisterCandidateByPublicExaminationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterCandidateByPublicExaminationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterCandidateByPublicExaminationMutation,
    RegisterCandidateByPublicExaminationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterCandidateByPublicExaminationMutation,
    RegisterCandidateByPublicExaminationMutationVariables
  >(RegisterCandidateByPublicExaminationDocument, options);
}
export type RegisterCandidateByPublicExaminationMutationHookResult = ReturnType<
  typeof useRegisterCandidateByPublicExaminationMutation
>;
export type RegisterCandidateByPublicExaminationMutationResult =
  Apollo.MutationResult<RegisterCandidateByPublicExaminationMutation>;
export type RegisterCandidateByPublicExaminationMutationOptions = Apollo.BaseMutationOptions<
  RegisterCandidateByPublicExaminationMutation,
  RegisterCandidateByPublicExaminationMutationVariables
>;
export const ResetPasswordDocument = gql`
  mutation resetPassword($code: String!, $password: String!) {
    resetPassword(code: $code, password: $password)
  }
`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      code: // value for 'code'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(
    ResetPasswordDocument,
    options,
  );
}
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const SendBugReportDocument = gql`
  mutation sendBugReport($input: SendBugReportInput!) {
    sendBugReport(input: $input)
  }
`;
export type SendBugReportMutationFn = Apollo.MutationFunction<
  SendBugReportMutation,
  SendBugReportMutationVariables
>;

/**
 * __useSendBugReportMutation__
 *
 * To run a mutation, you first call `useSendBugReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBugReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBugReportMutation, { data, loading, error }] = useSendBugReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendBugReportMutation(
  baseOptions?: Apollo.MutationHookOptions<SendBugReportMutation, SendBugReportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendBugReportMutation, SendBugReportMutationVariables>(
    SendBugReportDocument,
    options,
  );
}
export type SendBugReportMutationHookResult = ReturnType<typeof useSendBugReportMutation>;
export type SendBugReportMutationResult = Apollo.MutationResult<SendBugReportMutation>;
export type SendBugReportMutationOptions = Apollo.BaseMutationOptions<
  SendBugReportMutation,
  SendBugReportMutationVariables
>;
export const SetCandidateAgreementTrueDocument = gql`
  mutation setCandidateAgreementTrue {
    setCandidateAgreementTrue {
      id
      agreement
    }
  }
`;
export type SetCandidateAgreementTrueMutationFn = Apollo.MutationFunction<
  SetCandidateAgreementTrueMutation,
  SetCandidateAgreementTrueMutationVariables
>;

/**
 * __useSetCandidateAgreementTrueMutation__
 *
 * To run a mutation, you first call `useSetCandidateAgreementTrueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCandidateAgreementTrueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCandidateAgreementTrueMutation, { data, loading, error }] = useSetCandidateAgreementTrueMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetCandidateAgreementTrueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCandidateAgreementTrueMutation,
    SetCandidateAgreementTrueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCandidateAgreementTrueMutation,
    SetCandidateAgreementTrueMutationVariables
  >(SetCandidateAgreementTrueDocument, options);
}
export type SetCandidateAgreementTrueMutationHookResult = ReturnType<
  typeof useSetCandidateAgreementTrueMutation
>;
export type SetCandidateAgreementTrueMutationResult =
  Apollo.MutationResult<SetCandidateAgreementTrueMutation>;
export type SetCandidateAgreementTrueMutationOptions = Apollo.BaseMutationOptions<
  SetCandidateAgreementTrueMutation,
  SetCandidateAgreementTrueMutationVariables
>;
export const SetCandidateLanguageDocument = gql`
  mutation setCandidateLanguage($language: LANGUAGE!) {
    setCandidateLanguage(language: $language) {
      id
      language
      agreement
      phoneNumber
      candidateUsername {
        id
        login
      }
    }
  }
`;
export type SetCandidateLanguageMutationFn = Apollo.MutationFunction<
  SetCandidateLanguageMutation,
  SetCandidateLanguageMutationVariables
>;

/**
 * __useSetCandidateLanguageMutation__
 *
 * To run a mutation, you first call `useSetCandidateLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCandidateLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCandidateLanguageMutation, { data, loading, error }] = useSetCandidateLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSetCandidateLanguageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCandidateLanguageMutation,
    SetCandidateLanguageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCandidateLanguageMutation, SetCandidateLanguageMutationVariables>(
    SetCandidateLanguageDocument,
    options,
  );
}
export type SetCandidateLanguageMutationHookResult = ReturnType<
  typeof useSetCandidateLanguageMutation
>;
export type SetCandidateLanguageMutationResult =
  Apollo.MutationResult<SetCandidateLanguageMutation>;
export type SetCandidateLanguageMutationOptions = Apollo.BaseMutationOptions<
  SetCandidateLanguageMutation,
  SetCandidateLanguageMutationVariables
>;
export const SetCandidatePhoneNumberDocument = gql`
  mutation setCandidatePhoneNumber($phoneNumber: String!) {
    setCandidatePhoneNumber(phoneNumber: $phoneNumber) {
      id
      phoneNumber
    }
  }
`;
export type SetCandidatePhoneNumberMutationFn = Apollo.MutationFunction<
  SetCandidatePhoneNumberMutation,
  SetCandidatePhoneNumberMutationVariables
>;

/**
 * __useSetCandidatePhoneNumberMutation__
 *
 * To run a mutation, you first call `useSetCandidatePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCandidatePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCandidatePhoneNumberMutation, { data, loading, error }] = useSetCandidatePhoneNumberMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useSetCandidatePhoneNumberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCandidatePhoneNumberMutation,
    SetCandidatePhoneNumberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCandidatePhoneNumberMutation,
    SetCandidatePhoneNumberMutationVariables
  >(SetCandidatePhoneNumberDocument, options);
}
export type SetCandidatePhoneNumberMutationHookResult = ReturnType<
  typeof useSetCandidatePhoneNumberMutation
>;
export type SetCandidatePhoneNumberMutationResult =
  Apollo.MutationResult<SetCandidatePhoneNumberMutation>;
export type SetCandidatePhoneNumberMutationOptions = Apollo.BaseMutationOptions<
  SetCandidatePhoneNumberMutation,
  SetCandidatePhoneNumberMutationVariables
>;
export const LinkEmailDocument = gql`
  mutation linkEmail($email: String!) {
    linkEmail(email: $email) {
      id
      candidateUsername {
        id
        email
        emailIsConfirmed
      }
    }
  }
`;
export type LinkEmailMutationFn = Apollo.MutationFunction<
  LinkEmailMutation,
  LinkEmailMutationVariables
>;

/**
 * __useLinkEmailMutation__
 *
 * To run a mutation, you first call `useLinkEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkEmailMutation, { data, loading, error }] = useLinkEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useLinkEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<LinkEmailMutation, LinkEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LinkEmailMutation, LinkEmailMutationVariables>(
    LinkEmailDocument,
    options,
  );
}
export type LinkEmailMutationHookResult = ReturnType<typeof useLinkEmailMutation>;
export type LinkEmailMutationResult = Apollo.MutationResult<LinkEmailMutation>;
export type LinkEmailMutationOptions = Apollo.BaseMutationOptions<
  LinkEmailMutation,
  LinkEmailMutationVariables
>;
export const MeDocument = gql`
  query me {
    me {
      id
      phoneNumber
      language
      agreement
      fullName
      candidateUsername {
        id
        login
        email
        emailIsConfirmed
      }
      firstCompanyCandidate {
        id
        fullName
      }
    }
  }
`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export function useMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export function useMeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const GetUserDocument = gql`
  query getUser {
    me {
      id
      phoneNumber
      language
      fullName
      candidateUsername {
        id
        telegramUsername
        yandexEmail
        email
        emailIsConfirmed
      }
      firstCompanyCandidate {
        id
        fullName
        position
        organization
        email
      }
    }
  }
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const UpdateFirstCompanyCandidateDocument = gql`
  mutation updateFirstCompanyCandidate($firstCompanyCandidate: UpdateFirstCreatedCompaniesInput!) {
    updateFirstCompanyCandidate(input: $firstCompanyCandidate) {
      id
      email
      fullName
    }
  }
`;
export type UpdateFirstCompanyCandidateMutationFn = Apollo.MutationFunction<
  UpdateFirstCompanyCandidateMutation,
  UpdateFirstCompanyCandidateMutationVariables
>;

/**
 * __useUpdateFirstCompanyCandidateMutation__
 *
 * To run a mutation, you first call `useUpdateFirstCompanyCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFirstCompanyCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFirstCompanyCandidateMutation, { data, loading, error }] = useUpdateFirstCompanyCandidateMutation({
 *   variables: {
 *      firstCompanyCandidate: // value for 'firstCompanyCandidate'
 *   },
 * });
 */
export function useUpdateFirstCompanyCandidateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFirstCompanyCandidateMutation,
    UpdateFirstCompanyCandidateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateFirstCompanyCandidateMutation,
    UpdateFirstCompanyCandidateMutationVariables
  >(UpdateFirstCompanyCandidateDocument, options);
}
export type UpdateFirstCompanyCandidateMutationHookResult = ReturnType<
  typeof useUpdateFirstCompanyCandidateMutation
>;
export type UpdateFirstCompanyCandidateMutationResult =
  Apollo.MutationResult<UpdateFirstCompanyCandidateMutation>;
export type UpdateFirstCompanyCandidateMutationOptions = Apollo.BaseMutationOptions<
  UpdateFirstCompanyCandidateMutation,
  UpdateFirstCompanyCandidateMutationVariables
>;
